import axios from "axios";
import "./household";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const householdSignup = async (payload) => (await axios.post(`${API}/household/signup`, payload)).data;
export const addSampleDocument = async () => (await axios.post(`${API}/documents/sample`)).data;
export const resendVerifyEmail = async () => (await axios.post(`${API}/household/verify/resend`)).data;
export const householdFind = async (email) => (await axios.post(`${API}/household/find`, { email })).data;
export const fetchHousehold = async () => (await axios.get(`${API}/household`)).data;
export const adminOverview = async () => (await axios.get(`${API}/admin/overview`)).data;
export const adminHouseholds = async (q = "") => (await axios.get(`${API}/admin/households`, { params: q ? { q } : {} })).data;
export const adminHousehold = async (slug) => (await axios.get(`${API}/admin/households/${slug}`)).data;
export const makeMeAdminOptions = async () => (await axios.get(`${API}/members/make-me-admin`)).data;
export const makeMeAdmin = async (payload) => (await axios.post(`${API}/members/make-me-admin`, payload)).data;
export const adminEmailCode = async (email) => (await axios.post(`${API}/security/admin/email-code`, { email })).data;
export const adminSetPin = async (newPin) => (await axios.post(`${API}/security/admin/set-pin`, { new_pin: newPin })).data;
export const adminHouseholdVerifyResend = async (slug) => (await axios.post(`${API}/admin/households/${slug}/verify-resend`)).data;
export const adminHouseholdTicket = async (slug, subject, body) => (await axios.post(`${API}/admin/households/${slug}/ticket`, { subject, body })).data;
export const adminHouseholdArchive = async (slug) => (await axios.post(`${API}/admin/households/${slug}/archive`)).data;
export const adminHouseholdRestore = async (slug) => (await axios.post(`${API}/admin/households/${slug}/restore`)).data;
export const adminHouseholdDelete = async (slug, confirm) => (await axios.delete(`${API}/admin/households/${slug}`, { data: { confirm } })).data;
export const adminDeletedHouseholds = async () => (await axios.get(`${API}/admin/households/deleted/list`)).data;
export const adminAlerts = async () => (await axios.get(`${API}/admin/alerts`)).data;
export const adminAlertsSendNow = async () => (await axios.post(`${API}/admin/alerts/send-now`)).data;
export const adminAlertsToggle = async () => (await axios.post(`${API}/admin/alerts/toggle`)).data;
export const adminNudgeToggle = async () => (await axios.post(`${API}/admin/alerts/nudge-toggle`)).data;
export const adminNudgeNow = async (slug) => (await axios.post(`${API}/admin/alerts/nudge/${slug}`)).data;
export const adminPasskeyOptions = async () => (await axios.post(`${API}/webauthn/admin/options`)).data;
export const adminPasskeyVerify = async (credential) => (await axios.post(`${API}/webauthn/admin/verify`, credential)).data;
export const adminEmailPreview = async () => (await axios.get(`${API}/admin/email-preview`)).data;
export const adminEmailPreviewSend = async () => (await axios.post(`${API}/admin/email-preview/send`)).data;
export const adminInboxReceipts = async () => (await axios.get(`${API}/admin/inbox-receipts`)).data;
export const adminInboxReceiptsSave = async (p) => (await axios.put(`${API}/admin/inbox-receipts`, p)).data;
export const adminInboxReceiptsRollup = async () => (await axios.post(`${API}/admin/inbox-receipts/send-rollup`)).data;
export const adminSecrets = async () => (await axios.get(`${API}/admin/secrets`)).data;
export const adminUnsealPreview = async () => (await axios.post(`${API}/admin/unseal-preview`)).data;
export const voiceVoices = async () => (await axios.get(`${API}/voice/voices`)).data;
export const voiceStatus = async () => (await axios.get(`${API}/voice/status`)).data;
export const voiceTts = async (text, voice_id = "") => (await axios.post(`${API}/voice/tts`, { text, voice_id }, { responseType: "blob" })).data;
export const voiceLetterAudio = async (id) => (await axios.get(`${API}/voice/letters/${id}/audio`, { responseType: "blob" })).data;
export const voiceLetterGenerate = async (id, voice_id = "") => (await axios.post(`${API}/voice/letters/${id}/audio`, { voice_id })).data;
export const voiceSample = async (voice_id, lang = "en") => (await axios.get(`${API}/voice/voices/${encodeURIComponent(voice_id)}/sample`, { params: { lang }, responseType: "blob" })).data;
export const voiceNarration = async () => (await axios.get(`${API}/voice/narration`)).data;
export const voiceNarrationSave = async (body) => (await axios.put(`${API}/voice/narration`, body)).data;
export const voiceNarrateAll = async () => (await axios.post(`${API}/voice/letters/narrate-all`)).data;
export const voiceLetterTestSend = async (id) => (await axios.post(`${API}/voice/letters/${id}/test-send`, {})).data;
export const voiceSaveConfig = async (payload) => (await axios.put(`${API}/voice/config`, payload)).data;
export const voiceClearConfig = async () => (await axios.delete(`${API}/voice/config`)).data;
export const smsStatus = async () => (await axios.get(`${API}/sms/status`)).data;
export const smsSaveConfig = async (payload) => (await axios.put(`${API}/sms/config`, payload)).data;
export const smsClearConfig = async () => (await axios.delete(`${API}/sms/config`)).data;
export const smsSetPhone = async (phone, consent = true) => (await axios.put(`${API}/sms/phone`, { phone, consent })).data;
export const smsVerifyPhone = async (code) => (await axios.post(`${API}/sms/phone/verify`, { code })).data;
export const smsRemovePhone = async () => (await axios.delete(`${API}/sms/phone`)).data;
export const smsOtpChannel = async (channel) => (await axios.put(`${API}/sms/otp-channel`, { channel })).data;
export const smsTestInbound = async () => (await axios.post(`${API}/sms/test-inbound`)).data;
export const emailTransport = async () => (await axios.get(`${API}/email/transport`)).data;
export const saveEmailTransport = async (payload) => (await axios.put(`${API}/email/transport`, payload)).data;
export const testEmailTransport = async (to) => (await axios.post(`${API}/email/transport/test`, { to })).data;
export const pollEmailTransport = async () => (await axios.post(`${API}/email/transport/poll`)).data;
export const clearEmailTransport = async () => (await axios.delete(`${API}/email/transport`)).data;
export const helpAsk = async (question, articles) => (await axios.post(`${API}/help/ask`, { question, articles })).data;
export const trustSummary = async () => (await axios.get(`${API}/trust/summary`)).data;
export const setAdvisorAccess = async (enabled) => (await axios.put(`${API}/household/advisor-access`, { enabled })).data;

export const gmailStatus = async () => (await axios.get(`${API}/google/status`)).data;
export const gmailConnect = async () => (await axios.post(`${API}/google/connect`)).data;
export const gmailSync = async (id) => (await axios.post(`${API}/google/accounts/${id}/sync`)).data;
export const gmailSettings = async (id, payload) => (await axios.put(`${API}/google/accounts/${id}/settings`, payload)).data;
export const gmailDisconnect = async (id) => (await axios.delete(`${API}/google/accounts/${id}`)).data;
export const gmailSaveConfig = async (payload) => (await axios.put(`${API}/google/config`, payload)).data;
export const gmailClearConfig = async () => (await axios.delete(`${API}/google/config`)).data;
export const driveFolders = async (accountId, parent = "root") => (await axios.get(`${API}/google/drive/folders`, { params: { account_id: accountId, parent } })).data;
export const driveWatch = async (accountId, payload) => (await axios.post(`${API}/google/accounts/${accountId}/drive/folders`, payload)).data;
export const driveUnwatch = async (accountId, folderId) => (await axios.delete(`${API}/google/accounts/${accountId}/drive/folders/${folderId}`)).data;
export const driveSync = async (accountId) => (await axios.post(`${API}/google/accounts/${accountId}/drive/sync`)).data;
export const driveBackup = async (accountId) => (await axios.post(`${API}/google/accounts/${accountId}/drive/backup`)).data;
export const calendarEvents = async () => (await axios.get(`${API}/google/calendar/events`)).data;
export const calendarAdd = async (payload) => (await axios.post(`${API}/google/calendar/events`, payload)).data;
export const calendarRemove = async (key) => (await axios.delete(`${API}/google/calendar/events/${key}`)).data;
export const calendarSync = async (accountId) => (await axios.post(`${API}/google/calendar/sync`, null, { params: accountId ? { account_id: accountId } : {} })).data;
export const calendarAuto = async (accountId, auto) => (await axios.put(`${API}/google/accounts/${accountId}/calendar`, { auto })).data;
export const voiceCloneStatus = async () => (await axios.get(`${API}/voice/clone`)).data;
export const voiceCloneCreate = async (formData) => (await axios.post(`${API}/voice/clone`, formData)).data;
export const voiceClonePreview = async () => (await axios.post(`${API}/voice/clone/preview`, {}, { responseType: "blob" })).data;
export const voiceCloneDelete = async () => (await axios.delete(`${API}/voice/clone`)).data;
export const driveSuggestions = async (accountId, refresh = false) => (await axios.get(`${API}/google/accounts/${accountId}/drive/suggestions`, { params: refresh ? { refresh: true } : {} })).data;
export const letterShareCreate = async (letterId, payload) => (await axios.post(`${API}/voice/letters/${letterId}/share`, payload)).data;
export const letterShares = async (letterId) => (await axios.get(`${API}/voice/letters/${letterId}/shares`)).data;
export const letterShareRevoke = async (shareId) => (await axios.delete(`${API}/voice/letters/shares/${shareId}`)).data;
const hParam = () => { const h = new URLSearchParams(window.location.search).get("h"); return h ? { h } : {}; };
const giftQ = (token, extra = "") => { const h = hParam().h; return `?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}${extra}`; };
export const giftInfo = async (linkId) => (await axios.get(`${API}/gift/${linkId}/info`, { params: hParam() })).data;
export const giftAccess = async (linkId, code) => (await axios.post(`${API}/gift/${linkId}/access`, { code }, { params: hParam() })).data;
export const giftAlbumUrl = (linkId, token, dl = false) => `${API}/gift/${linkId}/album${giftQ(token, dl ? "&dl=1" : "")}`;
export const giftCoverUrl = (linkId, token) => `${API}/gift/${linkId}/cover.pdf${giftQ(token)}`;
export const albumGiftCreate = async (body) => (await axios.post(`${API}/voice/album/gifts`, body)).data;
export const albumGifts = async () => (await axios.get(`${API}/voice/album/gifts`)).data;
export const albumGiftRevoke = async (id) => (await axios.delete(`${API}/voice/album/gifts/${id}`)).data;
export const listenInfo = async (linkId) => (await axios.get(`${API}/listen/${linkId}/info`, { params: hParam() })).data;
export const listenAccess = async (linkId, code) => (await axios.post(`${API}/listen/${linkId}/access`, { code }, { params: hParam() })).data;
export const listenAudioUrl = (linkId, token) => { const h = hParam().h; return `${API}/listen/${linkId}/audio?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const letterShareSend = async (shareId, payload) => (await axios.post(`${API}/voice/letters/shares/${shareId}/send`, payload)).data;
export const letterPhotosAdd = async (letterId, formData) => (await axios.post(`${API}/legacy/${letterId}/photos`, formData)).data;
export const letterPhotoRemove = async (letterId, photoId) => (await axios.delete(`${API}/legacy/${letterId}/photos/${photoId}`)).data;
export const letterPhotoBlob = async (letterId, photoId) => (await axios.get(`${API}/legacy/${letterId}/photos/${photoId}`, { responseType: "blob" })).data;
export const setDocumentSeal = async (id, seal) => (await axios.put(`${API}/documents/${id}/seal`, seal)).data;
export const emergencyMediaUrl = (docId, token) => { const h = hParam().h; return `${API}/emergency-media/${docId}?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const letterPhotoUrl = (letterId, photoId, token) => { const h = hParam().h; return `${API}/legacy/${letterId}/photos/${photoId}?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const funeralResources = async () => (await axios.get(`${API}/funeral/resources`)).data;
export const funeralNearby = async (refresh = false, kind = "funeral") => (await axios.get(`${API}/funeral/nearby`, { params: { ...(refresh ? { refresh: true } : {}), ...(kind !== "funeral" ? { kind } : {}) }, timeout: 90000 })).data;
export const funeralSaveQuotes = async (quotes) => (await axios.put(`${API}/funeral/quotes`, { quotes })).data;
export const placesSaveConfig = async (f) => (await axios.put(`${API}/funeral/places-config`, f)).data;
export const placesClearConfig = async () => (await axios.delete(`${API}/funeral/places-config`)).data;
export const willResources = async () => (await axios.get(`${API}/will/resources`)).data;
export const funeralChooseQuote = async (quoteId) => (await axios.put(`${API}/funeral/quotes/choose`, { quote_id: quoteId })).data;
export const expensesList = async () => (await axios.get(`${API}/expenses`)).data;
export const expenseAdd = async (p) => (await axios.post(`${API}/expenses`, p)).data;
export const expenseUpdate = async (id, p) => (await axios.put(`${API}/expenses/${id}`, p)).data;
export const expenseDelete = async (id) => (await axios.delete(`${API}/expenses/${id}`)).data;
export const expenseReceipt = async (id, formData) => (await axios.post(`${API}/expenses/${id}/receipt`, formData, { timeout: 120000 })).data;
export const expensesCsvUrl = () => `${API}/expenses/export.csv`;
export const expensesStatementUrl = () => `${API}/expenses/statement.pdf`;
export const obituaryGet = async () => (await axios.get(`${API}/obituary`)).data;
export const obituaryDraft = async (p) => (await axios.post(`${API}/obituary/draft`, p, { timeout: 120000 })).data;
export const obituarySave = async (p) => (await axios.put(`${API}/obituary`, p)).data;
export const obituaryFile = async () => (await axios.post(`${API}/obituary/file`, {}, { timeout: 120000 })).data;
export const obituaryExportUrl = (fmt) => `${API}/obituary/export.${fmt}`;
export const thankyouList = async () => (await axios.get(`${API}/thankyou`)).data;
export const thankyouSettings = async (p) => (await axios.put(`${API}/thankyou/settings`, p)).data;
export const giftAdd = async (p) => (await axios.post(`${API}/thankyou`, p)).data;
export const giftUpdate = async (id, p) => (await axios.put(`${API}/thankyou/${id}`, p)).data;
export const giftDelete = async (id) => (await axios.delete(`${API}/thankyou/${id}`)).data;
export const giftDraft = async (id) => (await axios.post(`${API}/thankyou/${id}/draft`, {}, { timeout: 120000 })).data;
export const thankyouDraftAll = async () => (await axios.post(`${API}/thankyou/draft-all`, {}, { timeout: 300000 })).data;
export const thankyouPdfUrl = () => `${API}/thankyou/export.pdf`;
export const thankyouCsvUrl = () => `${API}/thankyou/addresses.csv`;
export const thankyouEnvelopesUrl = () => `${API}/thankyou/envelopes.pdf`;
export const thankyouLabelsUrl = () => `${API}/thankyou/labels.pdf`;
export const memorialVideoUrl = (linkId, token) => { const h = hParam().h; return `${API}/memorial/public/${linkId}/video?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const memorialGet = async () => (await axios.get(`${API}/memorial`)).data;
export const memorialSave = async (p) => (await axios.put(`${API}/memorial`, p)).data;
export const memorialPhotosAdd = async (formData, portrait = false) => (await axios.post(`${API}/memorial/photos`, formData, { params: portrait ? { portrait: true } : {}, timeout: 120000 })).data;
export const memorialPhotoRemove = async (id) => (await axios.delete(`${API}/memorial/photos/${id}`)).data;
export const memorialPhotoBlob = async (id) => (await axios.get(`${API}/memorial/photos/${id}`, { responseType: "blob" })).data;
export const memorialSetPortrait = async (id) => (await axios.put(`${API}/memorial/photos/${id}/portrait`)).data;
export const memorialPublish = async (p) => (await axios.post(`${API}/memorial/publish`, p)).data;
export const memorialUnpublish = async () => (await axios.post(`${API}/memorial/unpublish`)).data;
export const memorialSend = async (p) => (await axios.post(`${API}/memorial/send`, p)).data;
export const guestbookModerate = async (id, action) => (await axios.post(`${API}/memorial/guestbook/${id}/${action}`)).data;
export const guestbookDelete = async (id) => (await axios.delete(`${API}/memorial/guestbook/${id}`)).data;
export const memorialInfo = async (linkId) => (await axios.get(`${API}/memorial/public/${linkId}/info`, { params: hParam() })).data;
export const memorialAccess = async (linkId, code) => (await axios.post(`${API}/memorial/public/${linkId}/access`, { code }, { params: hParam() })).data;
export const memorialPhotoUrl = (linkId, photoId, token) => { const h = hParam().h; return `${API}/memorial/public/${linkId}/photo/${photoId}?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const memorialSign = async (linkId, p) => (await axios.post(`${API}/memorial/public/${linkId}/guestbook`, p, { params: hParam() })).data;
export const memorialEvent = async (linkId, kind, token) => (await axios.post(`${API}/memorial/public/${linkId}/event`, { kind, token }, { params: hParam() })).data;
export const memorialStats = async () => (await axios.get(`${API}/memorial/stats`)).data;
export const memorialWeekly = async (enabled) => (await axios.put(`${API}/memorial/weekly-summary`, { enabled })).data;
export const guestbookReply = async (id, message) => (await axios.post(`${API}/memorial/guestbook/${id}/reply`, { message })).data;
export const memorialCardUrl = (sheet = false) => `${API}/memorial/card.pdf${sheet ? "?sheet=1" : ""}`;
export const memorialMusicUrl = (linkId, token) => { const h = hParam().h; return `${API}/memorial/public/${linkId}/music?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const memorialGuestbookPdfUrl = () => `${API}/memorial/guestbook.pdf`;
export const memorialPhotoCaption = async (id, p) => (await axios.put(`${API}/memorial/photos/${id}`, p)).data;
export const adminResetContent = async (confirm) => (await axios.post(`${API}/admin/reset-content`, { confirm })).data;
export const adminSecurityCheckup = async () => (await axios.get(`${API}/admin/security-checkup`)).data;
export const adminFileEncryption = async () => (await axios.get(`${API}/admin/file-encryption`)).data;
export const adminFileEncryptionRun = async () => (await axios.post(`${API}/admin/file-encryption/run`)).data;
export const adminFieldEncryption = async () => (await axios.get(`${API}/admin/field-encryption`)).data;
export const adminFieldEncryptionRun = async () => (await axios.post(`${API}/admin/field-encryption/run`)).data;
export const adminKeyRetire = async () => (await axios.get(`${API}/admin/encryption/retire`)).data;
export const adminKeyRetireRun = async () => (await axios.post(`${API}/admin/encryption/retire`)).data;
export const adminKeyRetireUndo = async () => (await axios.delete(`${API}/admin/encryption/retire`)).data;
export const executorPreviewStatus = async () => (await axios.get(`${API}/executor-preview/status`)).data;
export const adminOps = async () => (await axios.get(`${API}/admin/ops`)).data;
export const adminOpsProbe = async (only) => (await axios.post(`${API}/admin/ops/probe`, { only: only || null }, { timeout: 150_000 })).data;
export const adminOpsFeedsRefresh = async () => (await axios.post(`${API}/admin/ops/feeds/refresh`)).data;
export const adminOpsVendorToggle = async (id, done) => (await axios.post(`${API}/admin/ops/vendor`, { id, done })).data;
export const securityPosture = async () => (await axios.get(`${API}/public/security-posture`)).data;
export const memorialTimelineSuggest = async () => (await axios.post(`${API}/memorial/timeline/suggest`, {}, { timeout: 120000 })).data;
export const memorialGuestbookPhoto = async (linkId, entryId, token, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/memorial/public/${linkId}/guestbook/${entryId}/photo`, fd, { params: { token, ...hParam() }, timeout: 120000 })).data; };
export const memorialGuestbookPhotoUrl = (linkId, entryId, token) => { const h = hParam().h; return `${API}/memorial/public/${linkId}/guestbook/${entryId}/photo?t=${encodeURIComponent(token)}${h ? `&h=${encodeURIComponent(h)}` : ""}`; };
export const guestbookPhotoBlob = async (id) => (await axios.get(`${API}/memorial/guestbook/${id}/photo`, { responseType: "blob" })).data;
export const approveAccessRequest = async (id) => (await axios.post(`${API}/access-requests/${id}/approve`)).data;
export const tributeGet = async () => (await axios.get(`${API}/tribute`)).data;
export const tributeSave = async (p) => (await axios.put(`${API}/tribute`, p)).data;
export const tributeAddItems = async (fd) => (await axios.post(`${API}/tribute/items`, fd, { timeout: 300000 })).data;
export const tributeUpdateItem = async (id, p) => (await axios.put(`${API}/tribute/items/${id}`, p)).data;
export const tributeDeleteItem = async (id) => (await axios.delete(`${API}/tribute/items/${id}`)).data;
export const tributeMediaBlob = async (id) => (await axios.get(`${API}/tribute/media/${id}`, { responseType: "blob" })).data;
export const tributeMusic = async (mood) => (await axios.post(`${API}/tribute/music`, { mood })).data;
export const tributeMusicBlob = async () => (await axios.get(`${API}/tribute/music`, { responseType: "blob" })).data;
export const tributeRender = async () => (await axios.post(`${API}/tribute/render`)).data;
export const tributeVideoBlob = async () => (await axios.get(`${API}/tribute/video`, { responseType: "blob", timeout: 300000 })).data;
export const advisorInsights = async (id) => (await axios.get(`${API}/advisor/clients/${id}/insights`)).data;
export const advisorAddTasks = async (id, items) => (await axios.post(`${API}/advisor/clients/${id}/tasks`, { items })).data;
export const advisorNotes = async (id) => (await axios.get(`${API}/advisor/clients/${id}/notes`)).data;
export const advisorAddNote = async (id, text, for_agenda) => (await axios.post(`${API}/advisor/clients/${id}/notes`, { text, for_agenda })).data;
export const advisorUpdateNote = async (id, noteId, text, for_agenda) => (await axios.put(`${API}/advisor/clients/${id}/notes/${noteId}`, { text, for_agenda })).data;
export const advisorDeleteNote = async (id, noteId) => (await axios.delete(`${API}/advisor/clients/${id}/notes/${noteId}`)).data;
export const sourceCheck = async () => (await axios.get(`${API}/admin/source-check`)).data;
export const sourceCheckRun = async () => (await axios.post(`${API}/admin/source-check/run`)).data;
export const priceWatch = async () => (await axios.get(`${API}/admin/price-watch`)).data;
export const priceWatchRun = async () => (await axios.post(`${API}/admin/price-watch/run`)).data;
export const priceWatchAck = async (id) => (await axios.post(`${API}/admin/price-watch/${id}/acknowledge`)).data;
export const estateDraftQuestions = async (kind, state) => (await axios.get(`${API}/estate-drafts/${kind}/questions`, { params: { state } })).data;
export const estateDraftDiff = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/diff`)).data;
export const lifeEvents = async () => (await axios.get(`${API}/life-events`)).data;
export const lifeEventApply = async (event, note = "") => (await axios.post(`${API}/life-events/${event}/apply`, { note })).data;
export const checkinSettings = async () => (await axios.get(`${API}/checkin`)).data;
export const checkinSave = async (payload) => (await axios.put(`${API}/checkin`, payload)).data;
export const checkinImHere = async () => (await axios.post(`${API}/checkin/im-here`)).data;
export const smallThingSettings = async () => (await axios.get(`${API}/small-thing/settings`)).data;
export const smallThingSave = async (enabled) => (await axios.put(`${API}/small-thing/settings`, { enabled })).data;
export const smallThingSend = async () => (await axios.post(`${API}/small-thing/send`)).data;
export const emergencyCardUrl = () => `${API}/emergency-card.pdf`;
export const fetchFridgeSheet = async () => (await axios.get(`${API}/fridge-sheet`)).data;
export const fridgeSheetUrl = (p = {}) => `${API}/fridge-sheet.pdf?${new URLSearchParams(p).toString()}`;
export const createHospitalShare = async (payload) => (await axios.post(`${API}/hospital-pack/share`, payload)).data;
export const listHospitalShares = async () => (await axios.get(`${API}/hospital-pack/shares`)).data;
export const shareDocUrl = (linkId, docId, token) => `${API}/share/${linkId}/doc/${docId}?t=${encodeURIComponent(token)}`;
export const doctorSendDefaults = async () => (await axios.get(`${API}/doctor-send/defaults`)).data;
export const doctorSend = async (payload) => (await axios.post(`${API}/doctor-send`, payload)).data;
export const doctorSendHistory = async () => (await axios.get(`${API}/doctor-send`)).data;
export const doctorSendRefresh = async (id) => (await axios.get(`${API}/doctor-send/${id}`)).data;
export const doctorSendUnconfirmed = async () => (await axios.get(`${API}/doctor-send/unconfirmed/list`)).data;
export const doctorSendMarkConfirmed = async (id) => (await axios.post(`${API}/doctor-send/${id}/confirm`)).data;
export const doctorConfirmInfo = async (token) => (await axios.get(`${API}/doctor-confirm/${token}`)).data;
export const doctorConfirm = async (token, name) => (await axios.post(`${API}/doctor-confirm/${token}`, { name })).data;
export const adminOpenIssues = async () => (await axios.get(`${API}/admin/open-issues`)).data;
export const aiFixDiagnose = async (id) => (await axios.post(`${API}/admin/open-issues/${id}/diagnose`)).data;
export const aiFixApply = async (id) => (await axios.post(`${API}/admin/open-issues/${id}/apply`)).data;
export const openIssuesPdf = async (id) => (await axios.get(`${API}/admin/open-issues/report.pdf`, { params: id ? { id } : {}, responseType: "blob" })).data;
export const resolvedIssues = async (range = {}) => (await axios.get(`${API}/admin/open-issues/resolved`, { params: range })).data;
export const resolvedIssuesPdf = async (key, range = {}) => (await axios.get(`${API}/admin/open-issues/resolved/report.pdf`, { params: key ? { key } : range, responseType: "blob" })).data;
export const monthlyHealthPdf = async (month) => (await axios.get(`${API}/admin/open-issues/monthly.pdf`, { params: { month }, responseType: "blob" })).data;
export const emailIssueReport = async (id, body) => (await axios.post(`${API}/admin/open-issues/${id}/email`, body)).data;
export const issueSupportEmail = async () => (await axios.get(`${API}/admin/open-issues/support-email`)).data;
export const setIssueSupportEmail = async (email) => (await axios.put(`${API}/admin/open-issues/support-email`, { email })).data;
export const aiFixHistory = async () => (await axios.get(`${API}/admin/open-issues/history`)).data;
export const aiAutofix = async () => (await axios.get(`${API}/admin/open-issues/autofix`)).data;
export const setAiAutofix = async (enabled) => (await axios.put(`${API}/admin/open-issues/autofix`, { enabled })).data;
export const runAiAutofix = async () => (await axios.post(`${API}/admin/open-issues/autofix/run`)).data;
export const faxUnread = async () => (await axios.get(`${API}/fax/unread`)).data;
export const markFaxSeen = async () => (await axios.post(`${API}/fax/seen`)).data;
export const faxLog = async () => (await axios.get(`${API}/fax/log`)).data;
export const faxHealth = async (refresh) => (await axios.get(`${API}/fax/health`, { params: { refresh } })).data;
export const inventoryScan = async (file, location = "") => { const fd = new FormData(); fd.append("file", file); fd.append("location", location); return (await axios.post(`${API}/inventory/scan`, fd, { timeout: 180000 })).data; };
export const inventoryList = async () => (await axios.get(`${API}/inventory`)).data;
export const inventoryUpdate = async (scanId, items, location) => (await axios.put(`${API}/inventory/${scanId}/items`, location === undefined ? { items } : { items, location })).data;
export const inventoryManual = async (room, items) => (await axios.post(`${API}/inventory/manual`, { room, items })).data;
export const inventoryEstimate = async (item) => (await axios.post(`${API}/inventory/estimate`, { name: item.name, description: item.description || "", category: item.category || "" })).data;
export const inventoryDelete = async (scanId) => (await axios.delete(`${API}/inventory/${scanId}`)).data;
export const inventoryToMemo = async (scanId, itemIds) => (await axios.post(`${API}/inventory/${scanId}/to-memo`, { item_ids: itemIds })).data;
export const inventoryCsvUrl = () => `${API}/inventory/export.csv`;
export const inventoryPhotoAdd = async (scanId, itemId, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/inventory/${scanId}/items/${itemId}/photos`, fd, { timeout: 120000 })).data; };
export const inventoryPhotoRemove = async (scanId, itemId, path) => (await axios.post(`${API}/inventory/${scanId}/items/${itemId}/photos/remove`, { path })).data;
export const inventoryPhotoBlob = async (path) => URL.createObjectURL((await axios.get(`${API}/inventory/photo/${path}`, { responseType: "blob" })).data);
export const inventoryAppraisals = async () => (await axios.get(`${API}/inventory/appraisals`)).data;
export const inventoryAppraisalSettings = async (p) => (await axios.put(`${API}/inventory/appraisals/settings`, p)).data;
export const elderOverview = async () => (await axios.get(`${API}/elder-safety`)).data;
export const elderTick = async (key, done) => (await axios.put(`${API}/elder-safety/signs/${key}`, { done })).data;
export const elderViewers = async (member_ids) => (await axios.put(`${API}/elder-safety/viewers`, { member_ids })).data;
export const elderLog = async () => (await axios.get(`${API}/elder-safety/log`)).data;
export const elderAdd = async (p) => (await axios.post(`${API}/elder-safety/log`, p)).data;
export const elderEdit = async (id, p) => (await axios.put(`${API}/elder-safety/log/${id}`, p)).data;
export const elderDelete = async (id) => (await axios.delete(`${API}/elder-safety/log/${id}`)).data;
export const elderFileAdd = async (id, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/elder-safety/log/${id}/files`, fd, { timeout: 120000 })).data; };
export const elderFileDelete = async (id, fid) => (await axios.delete(`${API}/elder-safety/log/${id}/files/${fid}`)).data;
export const elderFileOpen = async (id, fid) => URL.createObjectURL((await axios.get(`${API}/elder-safety/log/${id}/files/${fid}`, { responseType: "blob" })).data);
export const elderReportUrl = (cover = false, state = "") => `${API}/elder-safety/log.pdf${cover ? `?cover=1&state=${encodeURIComponent(state)}` : ""}`;
export const trustedContactGet = async () => (await axios.get(`${API}/trusted-contact`)).data;
export const trustedContactSave = async (p) => (await axios.put(`${API}/trusted-contact`, p)).data;
export const trustedContactPdfUrl = () => `${API}/trusted-contact/sheet.pdf`;
export const agentWatchGet = async () => (await axios.get(`${API}/agent-watch`)).data;
export const agentWatchSave = async (p) => (await axios.put(`${API}/agent-watch/settings`, p)).data;
export const inventoryAppraisers = async (category, near = "") => (await axios.get(`${API}/inventory/appraisers`, { params: { category, near } })).data;
export const agentWatchEmail = async (id, email) => (await axios.put(`${API}/agent-watch/agents/${id}/email`, { email })).data;
export const agentWatchReview = async (id, status, note) => (await axios.put(`${API}/agent-watch/alerts/${id}/review`, { status, note })).data;
export const inventoryBooking = async (scanId, itemId, p) => (await axios.put(`${API}/inventory/${scanId}/items/${itemId}/booking`, p)).data;
export const inventoryBookingClear = async (scanId, itemId) => (await axios.delete(`${API}/inventory/${scanId}/items/${itemId}/booking`)).data;
export const inventoryBookingDone = async (scanId, itemId, value) => (await axios.post(`${API}/inventory/${scanId}/items/${itemId}/booking/done`, { value })).data;
export const inventoryReportUpload = async (scanId, itemId, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/inventory/${scanId}/items/${itemId}/appraisal-report`, fd, { timeout: 120000 })).data; };
export const inventoryReportDelete = async (scanId, itemId) => (await axios.delete(`${API}/inventory/${scanId}/items/${itemId}/appraisal-report`)).data;
export const inventoryReportOpen = async (scanId, itemId) => URL.createObjectURL((await axios.get(`${API}/inventory/${scanId}/items/${itemId}/appraisal-report`, { responseType: "blob" })).data);
export const inventoryScheduleUrl = () => `${API}/inventory/schedule.pdf`;
export const trustedSignedUpload = async (bank, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/trusted-contact/signed`, fd, { params: { bank }, timeout: 120000 })).data; };
export const trustedSignedDelete = async (bank) => (await axios.delete(`${API}/trusted-contact/signed`, { params: { bank } })).data;
export const trustedSignedOpen = async (bank) => URL.createObjectURL((await axios.get(`${API}/trusted-contact/signed`, { params: { bank }, responseType: "blob" })).data);
export const coverageGet = async () => (await axios.get(`${API}/coverage`)).data;
export const coverageExtract = async (doc_id) => (await axios.post(`${API}/coverage/extract`, { doc_id }, { timeout: 120000 })).data;
export const coverageSaveLimits = async (limits, carrier, coverage_c = null) => (await axios.put(`${API}/coverage/limits`, { limits, carrier, coverage_c })).data;
export const coverageSaveAgent = async (name, email) => (await axios.put(`${API}/coverage/agent`, { name, email })).data;
export const coverageSend = async (note) => (await axios.post(`${API}/coverage/send-schedule`, { note }, { timeout: 120000 })).data;
export const invHistAdd = async (scanId, itemId, p) => (await axios.post(`${API}/inventory/${scanId}/items/${itemId}/history`, p)).data;
export const invHistDelete = async (scanId, itemId, hid) => (await axios.delete(`${API}/inventory/${scanId}/items/${itemId}/history/${hid}`)).data;
export const invHistReportUpload = async (scanId, itemId, hid, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/inventory/${scanId}/items/${itemId}/history/${hid}/report`, fd, { timeout: 120000 })).data; };
export const invHistReportOpen = async (scanId, itemId, hid) => URL.createObjectURL((await axios.get(`${API}/inventory/${scanId}/items/${itemId}/history/${hid}/report`, { responseType: "blob" })).data);
export const trustedRemind = async (remind) => (await axios.put(`${API}/trusted-contact/remind`, { remind })).data;
export const coverageTrend = async () => (await axios.get(`${API}/coverage/trend`)).data;
export const conciergePrep = async () => (await axios.get(`${API}/concierge-prep`)).data;
export const conciergePrepUpload = async (item, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/concierge-prep/upload`, fd, { params: { item }, timeout: 180000 })).data; };
export const conciergePrepEmail = async () => (await axios.post(`${API}/concierge-prep/email`)).data;
export const inventoryAppraisalSend = async () => (await axios.post(`${API}/inventory/appraisals/send`)).data;
export const identityStatus = async () => (await axios.get(`${API}/identity`)).data;
export const identitySetting = async (required) => (await axios.put(`${API}/identity/setting`, { required })).data;
export const identityStart = async () => (await axios.post(`${API}/identity/session`)).data;
export const identityRemind = async (memberId) => (await axios.post(`${API}/identity/remind/${memberId}`)).data;
export const shareCardCreate = async (payload) => (await axios.post(`${API}/share/readiness`, payload)).data;
export const shareCardsMine = async () => (await axios.get(`${API}/share/readiness/mine`)).data;
export const shareCardPublic = async (token) => (await axios.get(`${API}/share/readiness/${token}`)).data;
export const shareCardImage = (token) => `${API}/share/readiness/${token}.png`;
export const calendarFeed = async () => (await axios.get(`${API}/calendar`)).data;
export const calendarFeedCreate = async () => (await axios.post(`${API}/calendar`)).data;
export const calendarFeedDelete = async () => (await axios.delete(`${API}/calendar`)).data;
export const statementSettings = async () => (await axios.get(`${API}/statements`)).data;
export const statementSave = async (enabled) => (await axios.put(`${API}/statements`, { enabled })).data;
export const statementRun = async () => (await axios.post(`${API}/statements/run`, {}, { timeout: 180000 })).data;
export const estateDraftLang = async (lang) => (await axios.put(`${API}/estate-drafts/lang`, { lang })).data;
export const sourceCheckRegistry = async (where, sources) => (await axios.put(`${API}/admin/source-check/registry`, { where, sources })).data;
export const sourceCheckAck = async (url, note = "") => (await axios.post(`${API}/admin/source-check/acknowledge`, { url, note })).data;
export const adminSearchConsoleConfig = async (payload) => (await axios.put(`${API}/admin/search-console/config`, payload)).data;
export const adminSearchConsoleClear = async () => (await axios.delete(`${API}/admin/search-console/config`)).data;
export const blogSubscribe = async (email, source) => (await axios.post(`${API}/blog/subscribe`, { email, source })).data;
export const blogHelpful = async (slug) => (await axios.post(`${API}/blog/${slug}/helpful`)).data;
export const fetchBlogPreview = async (token) => (await axios.get(`${API}/blog/preview/${token}`)).data;
export const blogPreviewLink = async (id) => (await axios.post(`${API}/blog/admin/posts/${id}/preview-link`)).data;
export const blogSubscribers = async () => (await axios.get(`${API}/blog/admin/subscribers`)).data;
export const blogIllustrate = async (id) => (await axios.post(`${API}/blog/admin/posts/${id}/illustration`)).data;
export const blogRemoveIllustration = async (id) => (await axios.delete(`${API}/blog/admin/posts/${id}/illustration`)).data;
export const adminSearchConsole = async (refresh = false) => (await axios.get(`${API}/admin/search-console`, { params: refresh ? { refresh: true } : {} })).data;
export const adminDomainLaunch = async (refresh = false) => (await axios.get(`${API}/admin/domain-launch`, { params: refresh ? { refresh: true } : {} })).data;
export const adminRepointTwilio = async () => (await axios.post(`${API}/admin/domain-launch/twilio-webhook`)).data;
export const adminRegisterA2P = async () => (await axios.post(`${API}/admin/domain-launch/twilio-a2p`)).data;
export const adminIssueFixes = async () => (await axios.get(`${API}/admin/issue-fixes`)).data;
export const namecheapStatus = async () => (await axios.get(`${API}/admin/namecheap`, { timeout: 40000 })).data;
export const namecheapSuggest = async (id) => (await axios.get(`${API}/admin/namecheap/suggest/${id}`)).data;
export const namecheapPreview = async (body) => (await axios.post(`${API}/admin/namecheap/preview`, body, { timeout: 40000 })).data;
export const namecheapApply = async (body) => (await axios.post(`${API}/admin/namecheap/apply`, body, { timeout: 60000 })).data;
export const namecheapWatch = async () => (await axios.get(`${API}/admin/namecheap/watch`)).data;
export const namecheapWatchRun = async () => (await axios.post(`${API}/admin/namecheap/watch/run`, {}, { timeout: 60000 })).data;
export const mailHealth = async () => (await axios.get(`${API}/admin/namecheap/mail-health`, { timeout: 40000 })).data;
export const dnsUndoPreview = async (t) => (await axios.get(`${API}/admin/namecheap/undo/${t}`, { timeout: 40000 })).data;
export const dnsUndoApply = async (t) => (await axios.post(`${API}/admin/namecheap/undo/${t}`, {}, { timeout: 60000 })).data;
export const integrationHealth = async (p) => (await axios.get(`${API}/admin/integrations/${p}/health`, { timeout: 60000 })).data;
export const integrationWatchRun = async (p) => (await axios.post(`${API}/admin/integrations/${p}/watch/run`, {}, { timeout: 60000 })).data;
export const integrationFixPreview = async (p, id) => (await axios.get(`${API}/admin/integrations/${p}/fixes/${id}`, { timeout: 40000 })).data;
export const integrationFixApply = async (p, id) => (await axios.post(`${API}/admin/integrations/${p}/fixes/${id}`, {}, { timeout: 60000 })).data;
export const integrationUndoPreview = async (t) => (await axios.get(`${API}/admin/integrations/undo/${t}`)).data;
export const integrationUndoApply = async (t) => (await axios.post(`${API}/admin/integrations/undo/${t}`, {}, { timeout: 60000 })).data;
export const stripeDisputes = async () => (await axios.get(`${API}/admin/stripe/disputes`, { timeout: 40000 })).data;
export const stripeDisputeBuild = async (id) => (await axios.post(`${API}/admin/stripe/disputes/${id}/build`, {}, { timeout: 40000 })).data;
export const stripeDisputeSave = async (id, evidence) => (await axios.put(`${API}/admin/stripe/disputes/${id}`, { evidence })).data;
export const stripeDisputeSubmit = async (id) => (await axios.post(`${API}/admin/stripe/disputes/${id}/submit`, {}, { timeout: 40000 })).data;
export const weeklyHealthPreview = async () => (await axios.get(`${API}/admin/weekly-health/preview`, { timeout: 90000 })).data;
export const weeklyHealthSend = async () => (await axios.post(`${API}/admin/weekly-health/send`, {}, { timeout: 90000 })).data;
export const twilioAutoRechargeConfirm = async () => (await axios.post(`${API}/admin/integrations/twilio/auto-recharge`, {})).data;
export const stripeDisputeAccept = async (id) => (await axios.post(`${API}/admin/stripe/disputes/${id}/accept`, {}, { timeout: 40000 })).data;
export const adminSignoutPreview = async (t) => (await axios.get(`${API}/admin/devices/signout/${t}`)).data;
export const adminSignoutApply = async (t) => (await axios.post(`${API}/admin/devices/signout/${t}`, {})).data;
export const adminDevices = async () => (await axios.get(`${API}/admin/devices`)).data;
export const adminDeviceSignout = async (m, d) => (await axios.post(`${API}/admin/devices/${m}/${d}/signout`, {})).data;
export const forwardTestStart = async () => (await axios.post(`${API}/admin/mail/forward-test`, {}, { timeout: 30000 })).data;
export const ownerChecklist = async () => (await axios.get(`${API}/owner-checklist`)).data;
export const ownerChecklistSeen = async () => (await axios.post(`${API}/owner-checklist/seen`)).data;
export const docFollowup = async (id) => (await axios.get(`${API}/documents/${id}/followup`)).data;
export const docSetKit = async (id, on) => (await axios.post(`${API}/documents/${id}/emergency-kit`, { on })).data;
export const docFollowupReminder = async (id, date) => (await axios.post(`${API}/documents/${id}/followup-reminder`, { date })).data;
export const kitShare = async (body) => (await axios.post(`${API}/emergency/kit/share`, body)).data;
export const kitShares = async () => (await axios.get(`${API}/emergency/kit/shares`)).data;
export const kitShareCancel = async (id) => (await axios.delete(`${API}/emergency/kit/shares/${id}`)).data;
export const emergencyKitDocs = async () => (await axios.get(`${API}/emergency/kit`)).data;
export const esignEligibility = async (docId) => (await axios.get(`${API}/esign/eligibility`, { params: { doc_id: docId } })).data;
export const homeState = async () => (await axios.get(`${API}/home-state`)).data;
export const homeStateSave = async (state) => (await axios.put(`${API}/home-state`, { state })).data;
export const legalFix = async (rid, i) => (await axios.post(`${API}/legal-review/${rid}/findings/${i}/fix`)).data;
export const legalFixAccept = async (rid, i) => (await axios.post(`${API}/legal-review/${rid}/findings/${i}/accept`)).data;
export const legalFixReject = async (rid, i) => (await axios.post(`${API}/legal-review/${rid}/findings/${i}/reject`)).data;
const lrBase = (slug) => (slug ? `${API}/admin/households/${slug}/legal-review` : `${API}/legal-review`);
export const draftBlanks = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/blanks`)).data;
export const draftBlanksSuggest = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/blanks/suggest`, {}, { timeout: 90000 })).data;
export const draftBlanksApply = async (kind, values) => (await axios.post(`${API}/estate-drafts/${kind}/blanks/apply`, { values })).data;
export const legalReportUrl = () => `${API}/legal-review/report.pdf`;
export const legalReviewHistory = async (slug) => (await axios.get(`${lrBase(slug)}/history`)).data;
export const legalFixAll = async (rid) => (await axios.post(`${API}/legal-review/${rid}/fix-all`)).data;
export const legalAcceptAll = async (rid) => (await axios.post(`${API}/legal-review/${rid}/accept-all`)).data;
export const legalReviewSources = async (slug) => (await axios.get(`${lrBase(slug)}/sources`)).data;
export const legalReviewLatest = async (slug) => (await axios.get(`${lrBase(slug)}/latest`)).data;
export const legalReviewRun = async (slug, body) => (await axios.post(`${lrBase(slug)}/run`, body)).data;
export const forwardWatch = async () => (await axios.get(`${API}/admin/mail/forward-watch`)).data;
export const forwardTestStatus = async (c) => (await axios.get(`${API}/admin/mail/forward-test/${c}`)).data;
export const adminSigninMap = async () => (await axios.get(`${API}/admin/devices/map`)).data;
export const adminDeviceRename = async (m, d, nickname) => (await axios.put(`${API}/admin/devices/${m}/${d}`, { nickname })).data;
export const adminTrustPlace = async (body) => (await axios.post(`${API}/admin/devices/trusted`, body)).data;
export const adminUntrustPlace = async (id) => (await axios.delete(`${API}/admin/devices/trusted/${id}`)).data;
export const namecheapRestore = async (id) => (await axios.post(`${API}/admin/namecheap/backups/${id}/restore`, {}, { timeout: 60000 })).data;
export const adminLogFix = async (body) => (await axios.post(`${API}/admin/issue-fixes`, body, { timeout: 90000 })).data;
export const adminRecheckFix = async (id) => (await axios.post(`${API}/admin/issue-fixes/${id}/recheck`, {}, { timeout: 90000 })).data;
export const adminDismissFix = async (id) => (await axios.delete(`${API}/admin/issue-fixes/${id}`)).data;
export const adminRemoveFixSetting = async (name) => (await axios.delete(`${API}/admin/issue-fixes/settings/${name}`)).data;
export const adminA2PCampaign = async () => (await axios.get(`${API}/admin/a2p-campaign`)).data;
export const adminSaveA2PCampaign = async (body) => (await axios.put(`${API}/admin/a2p-campaign`, body)).data;
export const adminResetA2PCampaign = async () => (await axios.delete(`${API}/admin/a2p-campaign`)).data;
export const adminA2PLinks = async () => (await axios.post(`${API}/admin/a2p-campaign/links`, {}, { timeout: 90000 })).data;
export const smsCallWithCode = async () => (await axios.post(`${API}/sms/phone/call`)).data;
export const advisorSetDigest = async (enabled) => (await axios.put(`${API}/advisor/digest`, { enabled })).data;
export const advisorSendDigest = async () => (await axios.post(`${API}/advisor/digest/send-now`)).data;

const ADV = `${API}/advisor`;
export const advisorRegister = async (payload) => (await axios.post(`${ADV}/auth/register`, payload)).data;
export const advisorLogin = async (payload) => (await axios.post(`${ADV}/auth/login`, payload)).data;
export const advisorGoogle = async (session_id) => (await axios.post(`${ADV}/auth/google`, { session_id })).data;
export const advisorLogout = async () => (await axios.post(`${ADV}/auth/logout`)).data;
export const advisorMe = async () => (await axios.get(`${ADV}/me`)).data;
export const advisorVerify = async (token) => (await axios.post(`${ADV}/verify/${token}`)).data;
export const advisorResendVerify = async () => (await axios.post(`${ADV}/verify/resend`)).data;
export const advisorSaveBranding = async (payload) => (await axios.put(`${ADV}/branding`, payload)).data;
export const advisorUploadLogo = async (file) => {
  const form = new FormData();
  form.append("file", file);
  return (await axios.post(`${ADV}/branding/logo`, form, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const advisorLogoUrl = () => `${ADV}/branding/logo`;
export const advisorSignupPage = async () => (await axios.get(`${ADV}/portal`)).data;
export const advisorSecurityPackBlob = async (lang) => (await axios.get(`${ADV}/security-pack.pdf`, { params: { lang }, responseType: "blob" })).data;
export const advisorSecurityPackEmail = async (payload) => (await axios.post(`${ADV}/security-pack/email`, payload)).data;
export const advisorSignupPageSave = async (payload) => (await axios.put(`${ADV}/portal`, payload)).data;
export const portalInfo = async (slug) => (await axios.get(`${API}/portal/${slug}`)).data;
export const promoLanding = async (code) => (await axios.get(`${API}/promo/landing/${code}`)).data;
export const promoAdminList = async (sort = "created") => (await axios.get(`${API}/promo/admin`, { params: { sort } })).data;
export const adminAttention = async () => (await axios.get(`${API}/admin/attention`)).data;
export const adminScorecard = async () => (await axios.get(`${API}/admin/scorecard`)).data;
export const adminAttentionSettings = async (enabled) => (await axios.put(`${API}/admin/attention/settings`, { enabled })).data;
export const adminAttentionSend = async () => (await axios.post(`${API}/admin/attention/send`)).data;
export const adminAttentionPreview = async () => (await axios.get(`${API}/admin/attention/preview`)).data;
export const adminPartnerLeaderboard = async () => (await axios.get(`${API}/admin/attention/partners/leaderboard`)).data;
export const adminThankPartner = async (id, note) => (await axios.post(`${API}/admin/attention/partners/${id}/thank`, { note })).data;
export const adminPendingReview = async () => (await axios.get(`${API}/admin/attention/reviews/pending`)).data;
export const driveAutoBackup = async (accountId, enabled, passphrase) => (await axios.post(`${API}/google/accounts/${accountId}/drive/auto-backup`, { enabled, passphrase })).data;
export const driveBackupZip = async (accountId) => (await axios.post(`${API}/google/accounts/${accountId}/drive/backup-zip`)).data;
export const adminRepointResend = async () => (await axios.post(`${API}/admin/domain-launch/resend-webhook`)).data;
export const adminRepointFax = async () => (await axios.post(`${API}/admin/domain-launch/fax-webhook`)).data;
export const adminTrials = async (q = "") => (await axios.get(`${API}/admin/trials`, { params: q ? { q } : {} })).data;
export const adminTrialExtend = async (slug, days, reason = "") => (await axios.post(`${API}/admin/trials/households/${slug}/extend`, { days, reason })).data;
export const adminAdvisorTrial = async (id, payload) => (await axios.post(`${API}/admin/trials/advisors/${id}`, payload)).data;
export const promoCreate = async (payload) => (await axios.post(`${API}/promo/admin`, payload)).data;
export const promoToggle = async (code) => (await axios.patch(`${API}/promo/admin/${code}`)).data;
export const promoDelete = async (code) => (await axios.delete(`${API}/promo/admin/${code}`)).data;
export const promoTestPauseEmail = async () => (await axios.post(`${API}/promo/admin/test-pause-email`)).data;
export const advisorClients = async () => (await axios.get(`${ADV}/clients`)).data;
export const advisorCreateClient = async (payload) => (await axios.post(`${ADV}/clients`, payload)).data;
export const advisorResendInvite = async (id) => (await axios.post(`${ADV}/clients/${id}/resend`)).data;
export const advisorOpenVault = async (id) => (await axios.post(`${ADV}/clients/${id}/session`)).data;
export const advisorArchiveClient = async (id) => (await axios.delete(`${ADV}/clients/${id}`)).data;
export const advisorNudgePreview = async (id) => (await axios.get(`${ADV}/clients/${id}/nudge/preview`)).data;
export const advisorSendNudge = async (id) => (await axios.post(`${ADV}/clients/${id}/nudge`)).data;
export const advisorBilling = async (refresh = false) => (await axios.get(`${ADV}/billing`, { params: refresh ? { refresh: 1 } : {} })).data;
export const advisorCheckout = async (lookup_key) => (await axios.post(`${ADV}/billing/checkout`, { lookup_key })).data;
export const advisorConfirm = async (session_id) => (await axios.post(`${ADV}/billing/confirm`, { session_id })).data;
export const advisorPortal = async () => (await axios.post(`${ADV}/billing/portal`)).data;

export const fetchDocuments = async ({ category, search } = {}) => {
  const params = {};
  if (category && category !== "all") params.category = category;
  if (search) params.search = search;
  const { data } = await axios.get(`${API}/documents`, { params });
  return data;
};

export const fetchStats = async () => {
  const { data } = await axios.get(`${API}/stats`);
  return data;
};

export const uploadDocument = async (file, source = "upload", onProgress, tags = "") => {
  if (file.size > CHUNK_THRESHOLD) return uploadDocumentChunked(file, source, onProgress, tags);
  const form = new FormData();
  form.append("file", file);
  form.append("source", source);
  if (tags) form.append("tags", tags);
  const { data } = await axios.post(`${API}/documents/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress?.(e.total ? e.loaded / e.total : 0),
  });
  return data;
};

const CHUNK_THRESHOLD = 20 * 1024 * 1024;
const CHUNK_SIZE = 5 * 1024 * 1024;
const VIDEO_CHUNK_SIZE = 512 * 1024;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
// Network-level failures (TLS resets, dropped connections, 502/503/504 from a proxy) are retried with backoff; real 4xx errors are not.
const postWithRetry = async (url, body, config = {}, attempts = 4) => {
  for (let n = 0; ; n++) {
    try {
      return await axios.post(url, body, config);
    } catch (e) {
      const status = e.response?.status;
      const transient = !e.response || status === 502 || status === 503 || status === 504 || status === 408;
      if (!transient || n >= attempts - 1) throw e;
      await sleep(800 * 2 ** n);
    }
  }
};
const randomId = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");

export const uploadDocumentChunked = async (file, source = "upload", onProgress, tags = "") => {
  const total = Math.ceil(file.size / CHUNK_SIZE);
  const upload_id = randomId();
  let last = null;
  for (let i = 0; i < total; i++) {
    const form = new FormData();
    form.append("upload_id", upload_id);
    form.append("filename", file.name);
    form.append("index", i);
    form.append("total", total);
    form.append("source", source);
    if (tags) form.append("tags", tags);
    form.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE), file.name);
    last = (await postWithRetry(`${API}/uploads/chunk`, form, { timeout: 120_000 })).data;
    onProgress?.((i + 1) / total);
  }
  return last.document;
};

export const marketingVideos = async () => (await axios.get(`${API}/marketing/videos`)).data;
// A bounded recovery loop checks acknowledgements before resending. Never retry sign-in/permission errors.
const retryableVideoError = (e) => !["ERR_CANCELED", "UPLOAD_VALIDATION"].includes(e.code) && (
  !e.response || [408, 429, 500, 502, 503, 504].includes(e.response.status) ||
  (e.response.status === 409 && e.response.headers?.["retry-after"])
);
export const marketingVideoUpload = async (file, title, onProgress, resume = null) => {
  if (file.size < 1024 || file.size > 500 * 1024 * 1024) {
    throw Object.assign(new Error("Choose a video between 1 KB and 500 MB."), { code: "UPLOAD_VALIDATION" });
  }
  const total = Math.ceil(file.size / VIDEO_CHUNK_SIZE);
  const upload_id = resume?.upload_id || randomId();
  let pct = 0;
  for (let attempt = 0; attempt < 4; attempt++) {
    try {
      // This also checks Administrator access before transferring any bytes.
      const state = (await axios.get(`${API}/marketing/videos/chunk/${upload_id}`, { timeout: 15_000 })).data;
      if (state.done && state.video) { onProgress?.(100); return state.video; }
      const have = new Set(state.received || []);
      pct = Math.min(99, Math.round((have.size / total) * 100));
      onProgress?.(pct, have.size ? "Resuming confirmed pieces…" : resume ? "No temporary pieces remain on the server — sending the whole file again…" : "Uploading video…");
      for (let i = 0; i < total; i++) {
        // Replay the last piece when every piece arrived but finalization failed.
        if (have.has(i) && (i !== total - 1 || have.size < total)) continue;
        const form = new FormData();
        form.append("upload_id", upload_id);
        form.append("filename", file.name);
        form.append("index", i);
        form.append("total", total);
        form.append("title", title || "");
        form.append("chunk", file.slice(i * VIDEO_CHUNK_SIZE, (i + 1) * VIDEO_CHUNK_SIZE), file.name);
        if (have.size >= total - 1) onProgress?.(pct, "Saving video and preparing its poster…");
        const result = (await axios.post(`${API}/marketing/videos/chunk`, form, { timeout: 180_000 })).data;
        if (result.done && result.video) { onProgress?.(100); return result.video; }
        have.add(i);
        pct = Math.min(99, Math.round((have.size / total) * 100));
        onProgress?.(pct, "Uploading video…");
      }
      throw Object.assign(new Error("The server has not confirmed the finished video. Resume to check and send any missing pieces."), { code: "UPLOAD_INCOMPLETE" });
    } catch (e) {
      e.upload_id = upload_id;
      e.pct = pct;
      e.resumable = retryableVideoError(e);
      if (!e.resumable || attempt === 3) throw e;
      onProgress?.(pct, `Connection interrupted — checking saved progress (${attempt + 1}/3)…`);
      await sleep(1000 * 2 ** attempt);
    }
  }
};
export const siteVideoLabel = async (label, slot = "landing") => (await axios.patch(`${API}/site/video/label`, { label, slot })).data;
export const marketingVideoRename = async (id, payload) => (await axios.patch(`${API}/marketing/videos/${id}`, typeof payload === "string" ? { title: payload } : payload)).data;
export const marketingVideoSquare = async (id) => (await axios.post(`${API}/marketing/videos/${id}/square`)).data;
export const marketingVideoFormat = async (id) => (await axios.post(`${API}/marketing/videos/${id}/format`)).data;
export const marketingVideoCaptions = async (id) => (await axios.post(`${API}/marketing/videos/${id}/captions`)).data;
export const marketingVideoPoster = async (id, blob) => {
  const fd = new FormData();
  fd.append("file", blob, "poster.jpg");
  return (await axios.post(`${API}/marketing/videos/${id}/poster`, fd)).data;
};
export const marketingVideoDelete = async (id) => (await axios.delete(`${API}/marketing/videos/${id}`)).data;
export const marketingVideoUseOnLanding = async (id, caption = "") => (await axios.post(`${API}/marketing/videos/${id}/use-on-landing`, { caption })).data;
export const marketingVideoUseOn = async (id, slot, caption = "") => (await axios.post(`${API}/marketing/videos/${id}/use-on/${slot}`, null, { params: caption ? { caption } : {} })).data;
export const marketingVideoImport = async (url, title = "") => (await postWithRetry(`${API}/marketing/videos/import`, { url, title }, { timeout: 300_000 }, 2)).data;
export const socialChannels = async () => (await axios.get(`${API}/social/channels`)).data;
export const socialPosts = async (start, end, channel = "") => (await axios.get(`${API}/social/posts`, { params: { start, end, channel } })).data;
export const socialPostCreate = async (p) => (await axios.post(`${API}/social/posts`, p)).data;
export const socialPostPatch = async (id, p) => (await axios.patch(`${API}/social/posts/${id}`, p)).data;
export const socialPostDelete = async (id) => (await axios.delete(`${API}/social/posts/${id}`)).data;
export const socialPlan = async (p) => (await axios.post(`${API}/social/plan`, p, { timeout: 180_000 })).data;
export const socialKits = async () => (await axios.get(`${API}/social/kits`)).data;
export const socialLaunch = async () => (await axios.get(`${API}/social/launch`)).data;
export const socialLaunchTick = async (channel, step, done = true) => (await axios.post(`${API}/social/launch/tick`, { channel, step, done })).data;
export const socialMetaConnect = async (page_id, token) => (await axios.post(`${API}/social/meta/connect`, { page_id, token })).data;
export const socialMetaDisconnect = async () => (await axios.delete(`${API}/social/meta/connect`)).data;
export const socialLinkedInConnect = async (org_id, token, expires_in_days = 60) => (await axios.post(`${API}/social/linkedin/connect`, { org_id, token, expires_in_days })).data;
export const socialLinkedInDisconnect = async () => (await axios.delete(`${API}/social/linkedin/connect`)).data;
export const socialStarterPack = async (channel, posts) => (await axios.post(`${API}/social/launch/${channel}/starter-pack`, posts ? { posts } : {})).data;
export const socialStarterPackPreview = async (channel) => (await axios.post(`${API}/social/launch/${channel}/starter-pack/preview`)).data;
export const socialLinkedInOAuthStart = async () => (await axios.post(`${API}/social/linkedin/oauth/start`)).data;
export const socialLinkedInPickOrg = async (org_id) => (await axios.post(`${API}/social/linkedin/oauth/org`, { org_id })).data;
export const socialPublic = async (ch) => (await axios.get(`${API}/social/public/${ch}`)).data;
export const socialBestTimes = async (channel) => (await axios.get(`${API}/social/best-times`, { params: { channel } })).data;
export const socialPublishNow = async (id) => (await axios.post(`${API}/social/posts/${id}/publish`)).data;
export const marketingVideosPublic = async (orientation = "") => (await axios.get(`${API}/marketing/videos/public`, { params: orientation ? { orientation } : {} })).data;
export const marketingVideoPublic = async (id) => (await axios.get(`${API}/marketing/videos/${id}/public`)).data;
export const marketingVideoEvent = (id, kind, source = "share", partner = "") => axios.post(`${API}/marketing/videos/${id}/event`, { kind, source, partner }).catch(() => null);
export const advisorShareLinks = async () => (await axios.get(`${API}/marketing/videos/partner-links`)).data;

export const forwardDocument = async (payload) => {
  const { data } = await axios.post(`${API}/documents/forward`, payload);
  return data;
};

export const overrideCategory = async (id, category) => {
  const { data } = await axios.patch(`${API}/documents/${id}/category`, { category });
  return data;
};

export const deleteDocument = async (id) => {
  const { data } = await axios.delete(`${API}/documents/${id}`);
  return data;
};

export const fetchTrash = async () => (await axios.get(`${API}/documents/trash`)).data;
export const siteSocial = async () => (await axios.get(`${API}/site/social`)).data;
export const migrateCreate = async (source) => (await axios.post(`${API}/migrate/jobs`, { source })).data;
export const migrateChunk = async (jobId, form) => (await axios.post(`${API}/migrate/jobs/${jobId}/chunk`, form)).data;
export const migrateAnalyze = async (jobId) => (await axios.post(`${API}/migrate/jobs/${jobId}/analyze`)).data;
export const migrateStart = async (jobId, overrides) => (await axios.post(`${API}/migrate/jobs/${jobId}/start`, { overrides })).data;
export const migrateJob = async (jobId) => (await axios.get(`${API}/migrate/jobs/${jobId}`)).data;
export const migrateCancel = async (jobId) => (await axios.delete(`${API}/migrate/jobs/${jobId}`)).data;
export const migrateJobs = async () => (await axios.get(`${API}/migrate/jobs`)).data;
export const migrateResume = async (jobId) => (await axios.post(`${API}/migrate/jobs/${jobId}/resume`)).data;
export const migrateInsights = async () => (await axios.get(`${API}/migrate/insights`)).data;
export const migrateInsightsDismiss = async () => (await axios.post(`${API}/migrate/insights/dismiss`)).data;
export const siteBanner = async () => (await axios.get(`${API}/site/banner`)).data;
export const adminSiteBanner = async () => (await axios.get(`${API}/admin/site-banner`)).data;
export const saveSiteBanner = async (body) => (await axios.put(`${API}/admin/site-banner`, body)).data;
export const draftSiteBanner = async (notes, level) => (await axios.post(`${API}/admin/site-banner/draft`, { notes, level })).data;
export const siteBannerSeen = async (body) => (await axios.post(`${API}/site/banner/seen`, body)).data;
export const translateSiteBanner = async (message) => (await axios.post(`${API}/admin/site-banner/translate`, { message })).data;
export const siteBannerAudience = async () => (await axios.get(`${API}/admin/site-banner/blast`)).data;
export const siteBannerBlastPreview = async (pick) => (await axios.post(`${API}/admin/site-banner/blast/preview`, pick)).data;
export const siteBannerBlast = async (body) => (await axios.post(`${API}/admin/site-banner/blast`, body)).data;
export const bannerBlastHistory = async () => (await axios.get(`${API}/admin/site-banner/blast/history`)).data;
export const bannerBlastTest = async (texts) => (await axios.post(`${API}/admin/site-banner/blast/test`, { texts })).data;
export const bannerBackToNormal = async (incident_id, accept) => (await axios.post(`${API}/admin/site-banner/back-to-normal`, { incident_id, accept })).data;
export const adminAdvisorNotices = async () => (await axios.get(`${API}/admin/site-banner/advisor-notices`)).data;
export const clientAdvisorNotice = async () => (await axios.get(`${API}/advisor-notice`)).data;
export const advisorBanner = async () => (await axios.get(`${API}/advisor/banner`)).data;
export const saveAdvisorBanner = async (body) => (await axios.put(`${API}/advisor/banner`, body)).data;
export const reviewAdvisorNotice = async (advisorId, action, note = "") => (await axios.post(`${API}/admin/site-banner/advisor-notices/${advisorId}`, { action, note })).data;
export const cancelBannerBlast = async (id) => (await axios.delete(`${API}/admin/site-banner/blast/${id}`)).data;
export const advisorNoticeSeen = async (version, kind) => (await axios.post(`${API}/advisor-notice/seen`, { version, kind })).data;
export const saveBannerTemplates = async (items) => (await axios.put(`${API}/admin/site-banner/templates`, { items })).data;
export const resetBannerTemplates = async () => (await axios.delete(`${API}/admin/site-banner/templates`)).data;
export const siteLaunch = async () => (await axios.get(`${API}/site/launch`)).data;
export const siteHandles = async (refresh = false) => (await axios.get(`${API}/site/handles`, { params: refresh ? { refresh: true } : {} })).data;
export const siteSocialSave = async (links) => (await axios.put(`${API}/site/social`, { links })).data;
export const siteVideo = async (slot = "landing") => (await axios.get(`${API}/site/video`, { params: { slot } })).data;
export const supportTriage = async (id) => (await axios.post(`${API}/support/tickets/${id}/triage`)).data;
export const supportFixes = async (id) => (await axios.get(`${API}/support/tickets/${id}/fixes`)).data;
export const supportApplyFix = async (id, fixId) => (await axios.post(`${API}/support/tickets/${id}/fixes/${fixId}`)).data;
export const supportAutoAnswer = async () => (await axios.get(`${API}/support/auto-answer`)).data;
export const supportSetAutoAnswer = async (enabled) => (await axios.post(`${API}/support/auto-answer`, { enabled })).data;
export const supportIssues = async () => (await axios.get(`${API}/support/issues`)).data;
export const supportIssuesRecompute = async () => (await axios.post(`${API}/support/issues/recompute`)).data;
export const supportIssueStatus = async (id, status) => (await axios.post(`${API}/support/issues/${id}/${status}`)).data;
export const supportFeedback = async (body) => (await axios.post(`${API}/support/feedback`, body)).data;
export const smsReminderPref = async () => (await axios.get(`${API}/reminders/sms`)).data;
export const setSmsReminderPref = async (enabled) => (await axios.post(`${API}/reminders/sms`, { enabled })).data;
export const adminRemindInvite = async (slug) => (await axios.post(`${API}/admin/invites/${slug}/remind`)).data;
export const aiAllowance = async () => (await axios.get(`${API}/ai/allowance`)).data;
export const siteVisibility = async () => (await axios.get(`${API}/site/visibility`, { withCredentials: true })).data;
export const setSiteVisibility = async (body) => (await axios.put(`${API}/site/visibility`, body)).data;
export const joinWaitlist = async (body) => (await axios.post(`${API}/site/waitlist`, body)).data;
export const siteWaitlist = async () => (await axios.get(`${API}/site/waitlist`)).data;
export const removeWaitlistEntry = async (id) => (await axios.delete(`${API}/site/waitlist/${id}`)).data;
export const inviteAllWaitlist = async () => (await axios.post(`${API}/site/waitlist-invite-all`)).data;
export const inviteWaitlistEntry = async (id) => (await axios.post(`${API}/site/waitlist/${id}/invite`)).data;
export const checkBetaCode = async (code) => (await axios.get(`${API}/site/beta-codes/check`, { params: { code } })).data;
export const betaCodes = async () => (await axios.get(`${API}/site/beta-codes`)).data;
export const createBetaCode = async (body) => (await axios.post(`${API}/site/beta-codes`, body)).data;
export const deactivateBetaCode = async (id) => (await axios.delete(`${API}/site/beta-codes/${id}`)).data;
export const workPlan = async () => (await axios.get(`${API}/admin/work-plan`)).data;
export const workPlanDone = async (body) => (await axios.post(`${API}/admin/work-plan/done`, body)).data;
export const storageStatus = async () => (await axios.get(`${API}/admin/work-plan/storage`)).data;
export const storageMigrate = async () => (await axios.post(`${API}/admin/work-plan/storage/migrate`)).data;
export const markWelcomed = async () => (await axios.post(`${API}/security/me/welcomed`)).data;
export const releaseWindow = async () => (await axios.get(`${API}/security/release-window`)).data;
export const siteVideoSave = async (url, title = "") => (await axios.put(`${API}/site/video`, { url, title })).data;
export const siteVideoUpload = async (file, title = "", onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("title", title);
  return (await axios.post(`${API}/site/video/upload`, fd, { onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0) })).data;
};
export const siteVideoRemove = async () => (await axios.delete(`${API}/site/video`)).data;
export const siteCopyGuard = async () => (await axios.get(`${API}/site/copy-guard`)).data;
export const siteCopyGuardSave = async (enabled) => (await axios.put(`${API}/site/copy-guard`, { enabled })).data;
export const siteHit = (path, referrer) => axios.post(`${API}/site/hit`, { path, referrer }, { timeout: 5000 }).catch(() => {});
export const placesAutocomplete = async (q, session, mode = "address") => (await axios.get(`${API}/places/autocomplete`, { params: { q, session, mode } })).data;
export const placeDetails = async (placeId, session) => (await axios.get(`${API}/places/${placeId}`, { params: { session } })).data;
export const employerLead = async (payload) => (await axios.post(`${API}/site/employer-lead`, payload)).data;
export const advisorLead = async (payload) => (await axios.post(`${API}/site/advisor-lead`, payload)).data;
export const siteLeads = async () => (await axios.get(`${API}/site/leads`)).data;
// Support tickets
export const createSupportTicket = async (payload) => (await axios.post(`${API}/support/tickets`, payload)).data;
export const publicTicket = async (token) => (await axios.get(`${API}/support/tickets/t/${token}`)).data;
export const publicTicketReply = async (token, text) => (await axios.post(`${API}/support/tickets/t/${token}/reply`, { text })).data;
export const publicTicketRate = async (token, score, comment = "") => (await axios.post(`${API}/support/tickets/t/${token}/rating`, { score, comment })).data;
export const publicTicketAttach = async (token, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/support/tickets/t/${token}/attachments`, fd)).data; };
export const supportCanned = async () => (await axios.get(`${API}/support/canned`)).data;
export const supportAddCanned = async (title, body) => (await axios.post(`${API}/support/canned`, { title, body })).data;
export const supportDeleteCanned = async (id) => (await axios.delete(`${API}/support/canned/${id}`)).data;
export const briefingPreview = async () => (await axios.get(`${API}/chat/briefing/preview`)).data;
export const myBriefing = async () => (await axios.get(`${API}/chat/briefing/me`)).data;
export const saveMyBriefing = async (payload) => (await axios.put(`${API}/chat/briefing/me`, payload)).data;
export const supportTickets = async (status = "", q = "") => (await axios.get(`${API}/support/tickets`, { params: { ...(status ? { status } : {}), ...(q ? { q } : {}) } })).data;
export const supportPatchTicket = async (id, patch) => (await axios.patch(`${API}/support/tickets/${id}`, patch)).data;
export const supportReply = async (id, text) => (await axios.post(`${API}/support/tickets/${id}/reply`, { text })).data;
export const supportDeleteTicket = async (id) => (await axios.delete(`${API}/support/tickets/${id}`)).data;
export const supportMergeTicket = async (id, into, force = false) => (await axios.post(`${API}/support/tickets/${id}/merge`, { into, force })).data;
// Status page
export const statusSummary = async () => (await axios.get(`${API}/status`)).data;
export const statusSubscribe = async (payload) => (await axios.post(`${API}/status/subscribe`, payload)).data;
export const statusAdmin = async () => (await axios.get(`${API}/status/admin`)).data;
export const statusRobotConnect = async () => (await axios.post(`${API}/status/uptimerobot/connect`)).data;
export const statusDraftPostmortem = async (id) => (await axios.post(`${API}/status/incidents/${id}/postmortem/draft`)).data;
export const statusSavePostmortem = async (id, body) => (await axios.put(`${API}/status/incidents/${id}/postmortem`, body)).data;
export const fetchCareCosts = async (state, benefit) => (await axios.get(`${API}/insurance/care-costs`, { params: { ...(state ? { state } : {}), ...(benefit ? { benefit } : {}) } })).data;
export const launchRecap = async () => (await axios.get(`${API}/site/launch-recap`)).data;
export const fetchSurvivors = async () => (await axios.get(`${API}/executor-mode/survivors`)).data;
export const survivorClaimBlob = async (id) => (await axios.get(`${API}/executor-mode/survivors/${id}/claim.pdf`, { responseType: "blob" })).data;
export const saveSurvivors = async (body) => (await axios.put(`${API}/executor-mode/survivors`, body)).data;
export const statusCheckNow = async () => (await axios.post(`${API}/status/check-now`)).data;
export const statusCreateIncident = async (payload) => (await axios.post(`${API}/status/incidents`, payload)).data;
export const statusUpdateIncident = async (id, patch) => (await axios.patch(`${API}/status/incidents/${id}`, patch)).data;
export const siteLeadStatus = async (id, status) => (await axios.patch(`${API}/site/leads/${id}`, { status })).data;
export const siteLeadDelete = async (id) => (await axios.delete(`${API}/site/leads/${id}`)).data;
export const siteLeadAlerts = async () => (await axios.get(`${API}/site/lead-alerts`)).data;
export const siteLeadAlertsSave = async (prefs) => (await axios.put(`${API}/site/lead-alerts`, prefs)).data;
export const siteLeadsExportUrl = `${API}/site/leads/export.csv`;
export const securityWhitepaperUrl = `${API}/site/security-whitepaper.pdf`;
export const securitySummaryPdfUrl = `${API}/site/security-summary.pdf`;
export const securitySummary = async (lang = "en") => (await axios.get(`${API}/site/security-summary`, { params: { lang } })).data;
export const siteAnalytics = async (days = 30) => (await axios.get(`${API}/site/analytics`, { params: { days } })).data;
export const siteAnalyticsClear = async () => (await axios.delete(`${API}/site/analytics`)).data;
export const siteAnalyticsReset = async () => (await axios.post(`${API}/site/analytics/reset`)).data;
export const siteAnalyticsUndoReset = async () => (await axios.delete(`${API}/site/analytics/reset`)).data;
export const memorialStatsClear = async () => (await axios.delete(`${API}/memorial/stats`)).data;
export const markReminderRead = async (p) => (await axios.post(`${API}/reminders/read`, p)).data;
export const snoozeReminder = async (key, days) => (await axios.post(`${API}/reminders/snooze`, { key, days })).data;
export const guestbookRead = async (p) => (await axios.post(`${API}/memorial/guestbook/read`, p)).data;
export const adminSystemAlerts = async () => (await axios.get(`${API}/admin/system-alerts`)).data;
export const adminSystemAlertsRun = async () => (await axios.post(`${API}/admin/system-alerts/run`)).data;
export const authSession = async (session_id) => (await axios.post(`${API}/auth/session`, { session_id })).data;
export const authMe = async () => (await axios.get(`${API}/auth/me`)).data;
export const authLogout = async () => (await axios.post(`${API}/auth/logout`)).data;
export const authLink = async () => (await axios.post(`${API}/auth/link`)).data;
export const authUnlink = async () => (await axios.delete(`${API}/auth/link`)).data;
export const authResetPin = async (new_pin) => (await axios.post(`${API}/auth/reset-pin`, { new_pin })).data;
export const restoreDocument = async (id) => (await axios.post(`${API}/documents/${id}/restore`)).data;
export const purgeDocument = async (id) => (await axios.delete(`${API}/documents/${id}/purge`)).data;

export const fileUrl = (path, opts = {}) => `${API}/files/${path}${opts.inline ? "?inline=1" : ""}`;
export const fetchCategories = async () => (await axios.get(`${API}/categories`)).data;
export const createCategory = async (label, color) => (await axios.post(`${API}/categories`, { label, color })).data;
export const deleteCategory = async (key) => (await axios.delete(`${API}/categories/${key}`)).data;

export const fetchDocument = async (id) => {
  const { data } = await axios.get(`${API}/documents/${id}`);
  return data;
};

export const fetchReminders = async () => {
  const { data } = await axios.get(`${API}/reminders`);
  return data;
};

export const emailReminders = async (recipient_email, days_ahead = 90) => {
  const { data } = await axios.post(`${API}/reminders/email`, {
    recipient_email,
    days_ahead,
  });
  return data;
};

export const fetchEstatePlan = async () => {
  const { data } = await axios.get(`${API}/estate-plan`);
  return data;
};

export const saveEstatePlan = async (plan) => {
  const { data } = await axios.put(`${API}/estate-plan`, {
    contacts: plan.contacts,
    checklist: plan.checklist,
    digital_accounts: plan.digital_accounts,
    wishes: plan.wishes,
    home_address: plan.home_address || { line1: "", city: "", state: "", zip: "" },
  });
  return data;
};

export const securityStatus = async () => {
  const { data } = await axios.get(`${API}/security/status`);
  return data;
};

export const setPin = async (pin, name = "Owner", setupCode = "") => {
  const { data } = await axios.post(`${API}/security/set-pin`, { pin, name, setup_code: setupCode });
  return data;
};

export const changePin = async (current_pin, new_pin) => {
  const { data } = await axios.post(`${API}/security/change-pin`, { current_pin, new_pin });
  return data;
};

export const unlockVault = async (pin, member_id = null) => {
  const { data } = await axios.post(`${API}/security/unlock`, { pin, member_id });
  return data;
};

export const lockVault = async () => {
  const { data } = await axios.post(`${API}/security/lock`);
  return data;
};

export const fetchPeopleRoles = async () => (await axios.get(`${API}/people-roles`)).data;
export const setAgentStandby = async (id, standby) => (await axios.put(`${API}/members/${id}/standby`, { standby })).data;
export const agentHome = async () => (await axios.get(`${API}/agent/home`)).data;
export const fetchMe = async () => {
  const { data } = await axios.get(`${API}/security/me`);
  return data;
};

export const fetchMembers = async () => {
  const { data } = await axios.get(`${API}/members`);
  return data;
};

export const addMember = async (payload) => {
  const { data } = await axios.post(`${API}/members`, payload);
  return data;
};

export const updateMember = async (id, payload) => {
  const { data } = await axios.patch(`${API}/members/${id}`, payload);
  return data;
};

export const removeMember = async (id) => {
  const { data } = await axios.delete(`${API}/members/${id}`);
  return data;
};

export const setAutoLock = async (auto_lock_minutes) => {
  const { data } = await axios.post(`${API}/security/auto-lock`, { auto_lock_minutes });
  return data;
};

export const fetchActivity = async () => {
  const { data } = await axios.get(`${API}/activity`);
  return data;
};

const auditParams = (f = {}) => Object.fromEntries(Object.entries(f).filter(([, v]) => v !== "" && v !== null && v !== undefined && v !== false));
export const fetchAudit = async (filters) => (await axios.get(`${API}/audit`, { params: auditParams(filters) })).data;
export const fetchAuditSummary = async (filters) => (await axios.get(`${API}/audit/summary`, { params: auditParams({ from: filters.from, to: filters.to }) })).data;
export const auditExportUrl = (fmt, filters) => `${API}/audit/export.${fmt}?${new URLSearchParams(auditParams(filters)).toString()}`;
export const fetchAuditMonthly = async () => (await axios.get(`${API}/audit/monthly`)).data;
export const saveAuditMonthly = async (enabled) => (await axios.put(`${API}/audit/monthly`, { enabled })).data;
export const sendAuditMonthlyNow = async () => (await axios.post(`${API}/audit/monthly/send`)).data;
export const fetchAuditAlerts = async () => (await axios.get(`${API}/audit/alerts`)).data;
export const saveAuditAlerts = async (enabled) => (await axios.put(`${API}/audit/alerts`, { enabled })).data;
export const fetchAuditDevices = async () => (await axios.get(`${API}/audit/devices`)).data;

export const revealDocument = async (id) => {
  const { data } = await axios.post(`${API}/documents/${id}/reveal`);
  return data;
};

export const createEmergencyGrant = async (payload) => {
  const { data } = await axios.post(`${API}/emergency`, payload);
  return data;
};

export const listEmergencyGrants = async () => {
  const { data } = await axios.get(`${API}/emergency`);
  return data;
};

export const revokeEmergencyGrant = async (id) => {
  const { data } = await axios.delete(`${API}/emergency/${id}`);
  return data;
};

export const emergencyInfo = async (linkId) => {
  const { data } = await axios.get(`${API}/emergency/${linkId}/info`, { params: hParam() });
  return data;
};

export const emergencyAccess = async (linkId, code) => {
  const { data } = await axios.post(`${API}/emergency/${linkId}/access`, { code }, { params: hParam() });
  return data;
};

export const downloadExecutorPdf = async (lang = "en") => {
  const res = await axios.get(`${API}/estate-plan/export.pdf`, { responseType: "blob", params: { lang } });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "HearthVault-Executor-Plan.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchSubscription = async (refresh = false) => {
  const { data } = await axios.get(`${API}/subscription`, { params: refresh ? { refresh: 1 } : {} });
  return data;
};

export const openBillingPortal = async () => {
  const { data } = await axios.post(`${API}/payments/portal`, { origin_url: window.location.origin });
  return data;
};

export const createCheckout = async (lookup_key) => {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key,
    origin_url: window.location.origin,
  });
  return data;
};

export const paymentStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
};

export const fetchPlans = async () => {
  const { data } = await axios.get(`${API}/plans`);
  return data;
};

export const askVault = async (question) => {
  const { data } = await axios.post(`${API}/chat`, { question });
  return data;
};
export const runChatAction = async (action) => (await axios.post(`${API}/chat/action`, { action })).data;
export const chatTicket = async (email, subject = "") => (await axios.post(`${API}/chat/ticket`, { email, subject })).data;
export const briefingSettings = async () => (await axios.get(`${API}/chat/briefing/settings`)).data;
export const saveBriefingSettings = async (payload) => (await axios.put(`${API}/chat/briefing/settings`, payload)).data;
export const briefingSendNow = async () => (await axios.post(`${API}/chat/briefing/send-now`)).data;
export const chatBriefing = async () => (await axios.get(`${API}/chat/briefing`)).data;
export const transcribeChatAudio = async (blob) => {
  const fd = new FormData();
  fd.append("file", blob, blob.type.includes("mp4") ? "voice.mp4" : "voice.webm");
  return (await axios.post(`${API}/chat/transcribe`, fd)).data;
};
export const askVaultPhoto = async (file, question) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("question", question || "");
  return (await axios.post(`${API}/chat/photo`, fd)).data;
};
export const advisorChat = async (id, question) => (await axios.post(`${API}/advisor/clients/${id}/chat`, { question })).data;
export const advisorChatHistory = async (id) => (await axios.get(`${API}/advisor/clients/${id}/chat/history`)).data;
export const advisorChatClear = async (id) => (await axios.delete(`${API}/advisor/clients/${id}/chat/history`)).data;

export const fetchChatHistory = async () => {
  const { data } = await axios.get(`${API}/chat/history`);
  return data;
};

export const clearChatHistory = async () => {
  const { data } = await axios.delete(`${API}/chat/history`);
  return data;
};

export const fetchConcierge = async () => {
  const { data } = await axios.get(`${API}/concierge`);
  return data;
};

export const createInvite = async (payload) => {
  const { data } = await axios.post(`${API}/invites`, payload);
  return data;
};

export const listInvites = async () => {
  const { data } = await axios.get(`${API}/invites`);
  return data;
};

export const revokeInvite = async (id) => {
  const { data } = await axios.delete(`${API}/invites/${id}`);
  return data;
};

export const inviteInfo = async (token) => {
  const { data } = await axios.get(`${API}/invites/${token}/info`);
  return data;
};

export const acceptInvite = async (token, pin, name) => {
  const { data } = await axios.post(`${API}/invites/${token}/accept`, { pin, name });
  return data;
};

export const inboundStatus = async () => {
  const { data } = await axios.get(`${API}/inbound/status`);
  return data;
};

export const inboundTest = async (payload) => {
  const { data } = await axios.post(`${API}/inbound/test`, payload);
  return data;
};

export const recoveryAvailable = async () => {
  const { data } = await axios.get(`${API}/security/recovery-available`);
  return data;
};

export const recoverOwnerPin = async (reset_code, new_pin) => {
  const { data } = await axios.post(`${API}/security/recover`, { reset_code, new_pin });
  return data;
};

export const fetchReport = async (kind, year) => {
  const { data } = await axios.get(`${API}/reports/${kind}`, { params: year ? { year } : {} });
  return data;
};

export const reportFileUrl = (kind, year, ext = "pdf") => `${API}/reports/${kind}.${ext}${year ? `?year=${year}` : ""}`;

export const downloadFile = async (url, filename) => {
  const res = await axios.get(url, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const reindexDocuments = async () => {
  const { data } = await axios.post(`${API}/documents/reindex`);
  return data;
};

export const fetchTaxPack = async (year) => {
  const { data } = await axios.get(`${API}/tax-pack`, { params: year ? { year } : {} });
  return data;
};

export const updateTaxPackItem = async (year, itemId, payload) => {
  const { data } = await axios.put(`${API}/tax-pack/${year}/items/${itemId}`, payload);
  return data;
};

export const taxBundleUrl = (year) => `${API}/tax-pack/${year}/bundle.zip`;

// --- Estate Tax (Form 706) ---
export const fetchEstateTax = async () => (await axios.get(`${API}/estate-tax`)).data;
export const saveEstateTaxDecedent = async (payload) => (await axios.put(`${API}/estate-tax`, payload)).data;
export const addEstateTaxItem = async (sid, payload) => (await axios.post(`${API}/estate-tax/schedules/${sid}/items`, payload)).data;
export const editEstateTaxItem = async (sid, itemId, payload) => (await axios.put(`${API}/estate-tax/schedules/${sid}/items/${itemId}`, payload)).data;
export const deleteEstateTaxItem = async (sid, itemId) => (await axios.delete(`${API}/estate-tax/schedules/${sid}/items/${itemId}`)).data;
export const generateEstateTaxMemo = async () => (await axios.post(`${API}/estate-tax/memo`)).data;
export const estateTaxPdfUrl = `${API}/estate-tax/export.pdf`;
export const estateTaxCsvUrl = `${API}/estate-tax/export.csv`;
export const createEstateTaxShare = async (payload) => (await axios.post(`${API}/estate-tax/share`, payload)).data;
export const listEstateTaxShares = async () => (await axios.get(`${API}/estate-tax/shares`)).data;

export const createTaxShare = async (year, payload) => {
  const { data } = await axios.post(`${API}/tax-pack/${year}/share`, payload);
  return data;
};

export const listTaxShares = async (year) => {
  const { data } = await axios.get(`${API}/tax-pack/${year}/shares`);
  return data;
};

export const revokeTaxShare = async (id) => {
  const { data } = await axios.delete(`${API}/tax-pack/shares/${id}`);
  return data;
};

export const shareInfo = async (linkId) => {
  const { data } = await axios.get(`${API}/share/${linkId}/info`);
  return data;
};

export const shareAccess = async (linkId, code) => {
  const { data } = await axios.post(`${API}/share/${linkId}/access`, { code });
  return data;
};

export const shareBundleUrl = (linkId, token) => `${API}/share/${linkId}/bundle.zip?t=${encodeURIComponent(token)}`;

export const setRecoveryEmail = async (email) => {
  const { data } = await axios.put(`${API}/security/recovery-email`, { email });
  return data;
};

export const requestResetEmail = async () => {
  const { data } = await axios.post(`${API}/security/recovery/email`);
  return data;
};

export const resetLinkValid = async (token) => {
  const { data } = await axios.get(`${API}/security/recovery/${token}/valid`);
  return data;
};

export const completeReset = async (token, new_pin) => {
  const { data } = await axios.post(`${API}/security/recovery/${token}/complete`, { new_pin });
  return data;
};

export const fetchPasswordHealth = async () => {
  const { data } = await axios.get(`${API}/passwords/health`);
  return data;
};

export const markLoginHealth = async (id, payload) => {
  const { data } = await axios.put(`${API}/passwords/${id}/health`, payload);
  return data;
};

export const fetchBereavementPack = async () => {
  const { data } = await axios.get(`${API}/bereavement-pack`);
  return data;
};

export const updateBereavementItem = async (itemId, payload) => {
  const { data } = await axios.put(`${API}/bereavement-pack/items/${itemId}`, payload);
  return data;
};

export const bereavementBundleUrl = (lang = "en") => `${API}/bereavement-pack/bundle.zip?lang=${lang}`;

export const createBereavementShare = async (payload) => {
  const { data } = await axios.post(`${API}/bereavement-pack/share`, payload);
  return data;
};

export const listBereavementShares = async () => {
  const { data } = await axios.get(`${API}/bereavement-pack/shares`);
  return data;
};

export const fetchDigestSettings = async () => {
  const { data } = await axios.get(`${API}/digest/settings`);
  return data;
};

export const saveDigestSettings = async (payload) => {
  const { data } = await axios.put(`${API}/digest/settings`, payload);
  return data;
};

export const fetchDigestPreview = async () => {
  const { data } = await axios.get(`${API}/digest/preview`);
  return data;
};

export const sendDigestNow = async () => {
  const { data } = await axios.post(`${API}/digest/send`);
  return data;
};

export const fetchWeeklyDigestSettings = async () => (await axios.get(`${API}/weekly-digest/settings`)).data;
export const saveWeeklyDigestSettings = async (payload) => (await axios.put(`${API}/weekly-digest/settings`, payload)).data;
export const fetchWeeklyDigestPreview = async () => (await axios.get(`${API}/weekly-digest/preview`)).data;
export const sendWeeklyDigestNow = async () => (await axios.post(`${API}/weekly-digest/send`)).data;
export const fetchBlog = async (q = "", category = "") => (await axios.get(`${API}/blog`, { params: { ...(q ? { q } : {}), ...(category ? { category } : {}) } })).data;
export const fetchBlogPost = async (slug) => (await axios.get(`${API}/blog/${slug}`)).data;
export const blogAdminPosts = async () => (await axios.get(`${API}/blog/admin/posts`)).data;
export const blogSaveSettings = async (payload) => (await axios.put(`${API}/blog/admin/settings`, payload)).data;
export const blogGenerate = async () => (await axios.post(`${API}/blog/admin/generate`)).data;
export const estateDraftKinds = async () => (await axios.get(`${API}/estate-drafts/kinds`)).data;
export const estateDraftGenerate = async (kind, state, answers, lang = "en", clauses = {}) => (await axios.post(`${API}/estate-drafts/${kind}/generate`, { state, answers, lang, clauses })).data;
export const estateDraftSummary = async (kind, lang = "en") => (await axios.post(`${API}/estate-drafts/${kind}/summary`, null, { params: { lang } })).data;
export const estateDraftAutopilot = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/signing/autopilot`)).data;
export const readoutRecipients = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/readout/recipients`)).data;
export const readoutCreate = async (kind, payload) => (await axios.post(`${API}/estate-drafts/${kind}/readout`, payload)).data;
export const readoutList = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/readouts`)).data;
export const readoutRevoke = async (kind, id) => (await axios.delete(`${API}/estate-drafts/${kind}/readouts/${id}`)).data;
export const notarizeStatus = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/notarize`)).data;
export const notarizeStart = async (kind, payload = {}) => (await axios.post(`${API}/estate-drafts/${kind}/notarize`, payload)).data;
export const notarizeRefresh = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/notarize/refresh`)).data;
export const notarizeCancel = async (kind) => (await axios.delete(`${API}/estate-drafts/${kind}/notarize`)).data;
export const notaryConfig = async () => (await axios.get(`${API}/admin/notary-config`)).data;
export const notarySaveConfig = async (payload) => (await axios.put(`${API}/admin/notary-config`, payload)).data;
export const notaryClearConfig = async () => (await axios.delete(`${API}/admin/notary-config`)).data;
export const estateDraftSigningSheetUrl = (kind) => `${API}/estate-drafts/${kind}/signing-sheet`;
export const estateDraftAttorneyPack = async (kind, body) => (await axios.post(`${API}/estate-drafts/${kind}/attorney-pack`, body)).data;
export const estateDraftStatus = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}`)).data;
export const estateDraftChecked = async (kind, checked) => (await axios.put(`${API}/estate-drafts/${kind}/checked`, { checked })).data;
export const estateDraftSigned = async (kind, file) => { const f = new FormData(); f.append("file", file); return (await axios.post(`${API}/estate-drafts/${kind}/signed`, f)).data; };
export const switchAnalytics = async (days = 90) => (await axios.get(`${API}/blog/admin/switch-analytics`, { params: { days } })).data;
export const migrateUndo = async (jobId) => (await axios.post(`${API}/migrate/jobs/${jobId}/undo`)).data;
export const sourceCheckGuidesReviewed = async () => (await axios.post(`${API}/admin/source-check/guides-reviewed`)).data;
export const blogStats = async (postId = "") => (await axios.get(`${API}/blog/admin/stats`, { params: postId ? { post_id: postId } : {} })).data;
export const blogPublishSwitch = async (email = true) => (await axios.post(`${API}/blog/admin/publish-switch`, { email })).data;
export const migrateFollowup = async (category) => (await axios.post(`${API}/migrate/followups`, { category })).data;
export const migrateFollowupRemove = async (category) => (await axios.delete(`${API}/migrate/followups/${category}`)).data;
export const blogResetPostStats = async (id) => (await axios.post(`${API}/blog/admin/posts/${id}/reset-stats`)).data;
export const blogBroadcastStatus = async () => (await axios.get(`${API}/blog/broadcast/status`)).data;
export const blogBroadcastSync = async () => (await axios.post(`${API}/blog/broadcast/sync`)).data;
export const blogBroadcastSend = async (post_id, test_email = "") => (await axios.post(`${API}/blog/broadcast/send`, { post_id, test_email })).data;
export const blogResetAllStats = async () => (await axios.post(`${API}/blog/admin/reset-stats`)).data;
export const blogGenerateSwitch = async () => (await axios.post(`${API}/blog/admin/generate-switch`)).data;
export const blogSwitchStatus = async () => (await axios.get(`${API}/blog/admin/generate-switch`)).data;
export const blogUpdatePost = async (id, payload) => (await axios.put(`${API}/blog/admin/posts/${id}`, payload)).data;
export const blogDeletePost = async (id) => (await axios.delete(`${API}/blog/admin/posts/${id}`)).data;
export const blogFeeds = async () => (await axios.get(`${API}/blog/admin/feeds`)).data;
export const blogAddFeed = async (name, url) => (await axios.post(`${API}/blog/admin/feeds`, { name, url })).data;
export const blogToggleFeed = async (url, enabled) => (await axios.put(`${API}/blog/admin/feeds`, { url, enabled })).data;
export const blogRemoveFeed = async (url) => (await axios.delete(`${API}/blog/admin/feeds`, { params: { url } })).data;
export const blogTopics = async () => (await axios.get(`${API}/blog/admin/topics`)).data;
export const blogRefreshTopics = async () => (await axios.post(`${API}/blog/admin/topics/refresh`)).data;
export const blogAddTopic = async (title) => (await axios.post(`${API}/blog/admin/topics`, { title })).data;
export const blogApproveTopic = async (id) => (await axios.post(`${API}/blog/admin/topics/${id}/approve`)).data;
export const blogRejectTopic = async (id) => (await axios.post(`${API}/blog/admin/topics/${id}/reject`)).data;
export const inboundLog = async (limit = 20) => (await axios.get(`${API}/inbound/log`, { params: { limit } })).data;

export const fetchLibrary = async () => {
  const { data } = await axios.get(`${API}/library`);
  return data;
};

export const updateLibrarySlot = async (slotId, payload) => {
  const { data } = await axios.put(`${API}/library/${slotId}`, payload);
  return data;
};

export const libraryInventoryUrl = () => `${API}/library/inventory.pdf`;

export const fetchBuilderTemplates = async () => {
  const { data } = await axios.get(`${API}/builder/templates`);
  return data;
};

export const fetchBuilderDraft = async (templateId) => {
  const { data } = await axios.get(`${API}/builder/${templateId}`);
  return data;
};

export const saveBuilderDraft = async (templateId, answers) => {
  const { data } = await axios.put(`${API}/builder/${templateId}`, { answers });
  return data;
};

export const generateBuilderDoc = async (templateId) => {
  const { data } = await axios.post(`${API}/builder/${templateId}/generate`);
  return data;
};

export const plaidStatus = async () => {
  const { data } = await axios.get(`${API}/plaid/status`);
  return data;
};

export const plaidLinkToken = async () => {
  const { data } = await axios.post(`${API}/plaid/link-token`);
  return data;
};

export const plaidUpdateLinkToken = async (itemId) => {
  const { data } = await axios.post(`${API}/plaid/items/${itemId}/update-link-token`);
  return data;
};

export const plaidExchange = async (payload) => {
  const { data } = await axios.post(`${API}/plaid/exchange`, payload);
  return data;
};

export const fetchInstitutions = async () => {
  const { data } = await axios.get(`${API}/plaid/institutions`);
  return data;
};

export const refreshInstitution = async (itemId) => {
  const { data } = await axios.post(`${API}/plaid/items/${itemId}/refresh`);
  return data;
};

export const removeInstitution = async (itemId) => {
  const { data } = await axios.delete(`${API}/plaid/items/${itemId}`);
  return data;
};

export const updateLtcTerms = async (id, body) => (await axios.put(`${API}/insurance/${id}/ltc`, body)).data;
export const fetchInsurance = async () => {
  const { data } = await axios.get(`${API}/insurance`);
  return data;
};

export const reviewCheckout = async (id) => (await axios.post(`${API}/library/review-request/${id}/checkout`, { origin_url: window.location.origin })).data;
export const signingCard = async (state) => (await axios.get(`${API}/signing-card`, { params: { state } })).data;
export const ruleCheck = async () => (await axios.get(`${API}/admin/rule-check`)).data;
export const ruleCheckRun = async (state) => (await axios.post(`${API}/admin/rule-check/run`, { state: state || null })).data;
export const ruleCheckAck = async (state, note = "") => (await axios.post(`${API}/admin/rule-check/acknowledge`, { state, note })).data;

export const createReviewRequest = async (payload) => {
  const { data } = await axios.post(`${API}/library/review-request`, payload);
  return data;
};

export const listReviewRequests = async () => {
  const { data } = await axios.get(`${API}/library/review-requests`);
  return data;
};

export const bankStatus = async () => {
  const { data } = await axios.get(`${API}/bank/status`);
  return data;
};

export const bankSession = async () => {
  const { data } = await axios.post(`${API}/bank/session`);
  return data;
};

export const bankComplete = async (sessionId) => {
  const { data } = await axios.post(`${API}/bank/complete`, { session_id: sessionId });
  return data;
};

export const fetchBankAccounts = async () => {
  const { data } = await axios.get(`${API}/bank/accounts`);
  return data;
};

export const refreshBankAccount = async (accountId) => {
  const { data } = await axios.post(`${API}/bank/accounts/${accountId}/refresh`);
  return data;
};

export const disconnectBankAccount = async (accountId) => {
  const { data } = await axios.post(`${API}/bank/accounts/${accountId}/disconnect`);
  return data;
};

export const fetchOnboarding = async () => {
  const { data } = await axios.get(`${API}/onboarding`);
  return data;
};

export const dismissOnboarding = async () => {
  const { data } = await axios.post(`${API}/onboarding/dismiss`);
  return data;
};

export const nudgeInvite = async (inviteId) => {
  const { data } = await axios.post(`${API}/invites/${inviteId}/nudge`);
  return data;
};

export const fetchNetWorth = async () => {
  const { data } = await axios.get(`${API}/networth`);
  return data;
};

export const fetchBeneficiaries = async () => {
  const { data } = await axios.get(`${API}/beneficiaries`);
  return data;
};

export const saveBeneficiaries = async (targetId, payload) => {
  const { data } = await axios.put(`${API}/beneficiaries/${targetId}`, payload);
  return data;
};

export const addBeneficiaryTarget = async (payload) => {
  const { data } = await axios.post(`${API}/beneficiaries/targets`, payload);
  return data;
};

export const removeBeneficiaryTarget = async (id) => {
  const { data } = await axios.delete(`${API}/beneficiaries/targets/${id}`);
  return data;
};

export const uploadBeneficiaryLetter = async (targetId, file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/beneficiaries/${targetId}/letter`, form, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
};

export const pickBeneficiaryLetter = async (targetId, document_id) => {
  const { data } = await axios.put(`${API}/beneficiaries/${targetId}/letter`, { document_id });
  return data;
};

export const detachBeneficiaryLetter = async (targetId) => {
  const { data } = await axios.delete(`${API}/beneficiaries/${targetId}/letter`);
  return data;
};

export const fetchAnnualReviewSettings = async () => {
  const { data } = await axios.get(`${API}/annual-review/settings`);
  return data;
};

export const saveAnnualReviewSettings = async (payload) => {
  const { data } = await axios.put(`${API}/annual-review/settings`, payload);
  return data;
};

export const fetchAnnualReviewPreview = async () => {
  const { data } = await axios.get(`${API}/annual-review/preview`);
  return data;
};

export const sendAnnualReviewNow = async () => {
  const { data } = await axios.post(`${API}/annual-review/send`);
  return data;
};

export const fetchCheckup = async () => {
  const { data } = await axios.get(`${API}/annual-review`);
  return data;
};

export const setCheckupItem = async (key, done) => {
  const { data } = await axios.put(`${API}/annual-review/items/${encodeURIComponent(key)}`, { done });
  return data;
};

export const eraseVault = async (pin, confirm) => {
  const { data } = await axios.post(`${API}/vault/erase`, { pin, confirm });
  return data;
};

export const fetchGuide = async () => {
  const { data } = await axios.get(`${API}/guide`);
  return data;
};

export const fetchReferral = async () => {
  const { data } = await axios.get(`${API}/referral`);
  return data;
};

export const recordReferralVisit = async (code) => {
  const { data } = await axios.post(`${API}/referral/visit`, { code, source: "welcome" });
  return data;
};

export const setReferredBy = async (code) => {
  const { data } = await axios.put(`${API}/referral/referred-by`, { code });
  return data;
};

export const downloadCheatsheet = async (payload) => {
  const { data } = await axios.post(`${API}/guide/cheatsheet`, payload, { responseType: "blob" });
  return data;
};

export const unlockWithOtp = async (challenge_id, code) => {
  const { data } = await axios.post(`${API}/security/unlock/otp`, { challenge_id, code });
  return data;
};
export const fetchTwoFactor = async () => (await axios.get(`${API}/security/two-factor`)).data;
export const saveTwoFactor = async (payload) => (await axios.put(`${API}/security/two-factor`, payload)).data;
export const fetchStorage = async () => (await axios.get(`${API}/storage`)).data;
export const downloadBackup = async (passphrase) => { const r = await axios.post(`${API}/backup`, { passphrase }, { responseType: "blob" }); return { blob: r.data, verified: r.headers["x-backup-verified"] === "1", files: Number(r.headers["x-backup-files"] || 0) }; };
export const fetchReleaseWindow = async () => (await axios.get(`${API}/security/release-window`)).data;
export const setReleaseWindow = async (days) => (await axios.put(`${API}/security/release-window`, { days })).data;
export const replaceDocumentFile = async (id, file) => {
  const form = new FormData();
  form.append("file", file);
  return (await axios.post(`${API}/documents/${id}/replace`, form, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const fetchVersions = async (id) => (await axios.get(`${API}/documents/${id}/versions`)).data;
export const versionDownloadUrl = (id, index) => `${API}/documents/${id}/versions/${index}/download`;
export const fetchLocations = async () => (await axios.get(`${API}/locations`)).data;
export const saveLocation = async (payload, id) => (id ? (await axios.put(`${API}/locations/${id}`, payload)).data : (await axios.post(`${API}/locations`, payload)).data);
export const deleteLocation = async (id) => (await axios.delete(`${API}/locations/${id}`)).data;
export const fetchLetters = async () => (await axios.get(`${API}/legacy`)).data;
export const saveLetter = async (payload, id) => (id ? (await axios.put(`${API}/legacy/${id}`, payload)).data : (await axios.post(`${API}/legacy`, payload)).data);
export const deleteLetter = async (id) => (await axios.delete(`${API}/legacy/${id}`)).data;
export const fetchAccessRequests = async () => (await axios.get(`${API}/access-requests`)).data;
export const requestAccess = async (payload) => (await axios.post(`${API}/access-requests`, payload)).data;
export const uploadDeathCertificate = async (id, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/access-requests/${id}/death-certificate`, fd)).data; };
export const verifiedReleaseSettings = async () => (await axios.get(`${API}/access-requests/verified-release`)).data;
export const setVerifiedRelease = async (enabled) => (await axios.put(`${API}/access-requests/verified-release`, { enabled })).data;
export const privateAiSettings = async () => (await axios.get(`${API}/privacy/ai`)).data;
export const setPrivateAi = async (enabled) => (await axios.put(`${API}/privacy/ai`, { enabled })).data;
export const fetchPrivateIndex = async (since = "") => (await axios.get(`${API}/privacy/index`, { params: since ? { since } : {} })).data;
export const askVaultPrivate = async (question, snippets, history) => (await axios.post(`${API}/privacy/ask`, { question, snippets, history })).data;
export const setDeathRecordSettings = async (payload) => (await axios.put(`${API}/access-requests/death-record/settings`, payload)).data;
export const deathRecordStatus = async () => (await axios.get(`${API}/access-requests/death-record/status`)).data;
export const recheckDeathRecord = async (id) => (await axios.post(`${API}/access-requests/${id}/death-record/check`)).data;
export const reviewPrompt = async () => (await axios.get(`${API}/reviews/prompt`)).data;
export const reviewDismiss = async () => (await axios.post(`${API}/reviews/dismiss`)).data;
export const leaveReview = async (payload) => (await axios.post(`${API}/reviews`, payload)).data;
export const listReviews = async () => (await axios.get(`${API}/reviews`)).data;
export const moderateReview = async (id, status) => (await axios.post(`${API}/reviews/${id}/moderate`, { status })).data;
export const publicReviews = async () => (await axios.get(`${API}/site/reviews`)).data;
export const publicStories = async () => (await axios.get(`${API}/site/stories`)).data;
export const publicStory = async (slug) => (await axios.get(`${API}/site/stories/${slug}`)).data;
export const adminStories = async () => (await axios.get(`${API}/admin/stories`)).data;
export const adminStorySave = async (s) => (s.id ? (await axios.put(`${API}/admin/stories/${s.id}`, s)).data : (await axios.post(`${API}/admin/stories`, s)).data);
export const adminStoryDelete = async (id) => (await axios.delete(`${API}/admin/stories/${id}`)).data;
export const adminStoryDraft = async (brief, review_id = "") => (await axios.post(`${API}/admin/stories/draft`, { brief, review_id })).data;
export const reviewPrice = async () => (await axios.get(`${API}/library/review-price`)).data;
export const attorneyFinder = async ({ state = "", location = "" } = {}) => (await axios.get(`${API}/library/attorney-finder`, { params: { ...(state ? { state } : {}), ...(location ? { location } : {}) } })).data;
export const reviewPartner = async () => (await axios.get(`${API}/library/review/partner`)).data;
export const reviewPartnerSave = async (payload) => (await axios.put(`${API}/library/review/partner`, payload)).data;
export const firmShortlist = async () => (await axios.get(`${API}/library/firm-shortlist`)).data;
export const firmShortlistAdd = async (firm) => (await axios.post(`${API}/library/firm-shortlist`, firm)).data;
export const firmShortlistRemove = async (slug) => (await axios.delete(`${API}/library/firm-shortlist/${encodeURIComponent(slug)}`)).data;
export const reviewMarkDone = async (id) => (await axios.post(`${API}/library/review-requests/${id}/done`)).data;
export const reviewComments = async () => (await axios.get(`${API}/library/review-comments`)).data;
export const reviewCommentReply = async (id, text) => (await axios.post(`${API}/library/review-comments/${id}/reply`, { text })).data;
export const executorMode = async () => (await axios.get(`${API}/executor-mode`)).data;
export const executorProfileSave = async (payload) => (await axios.put(`${API}/executor-mode/profile`, payload)).data;
export const executorTaskDone = async (id, done) => (await axios.put(`${API}/executor-mode/tasks/${id}`, { done })).data;
export const executorLetterBlob = async (kind) => (await axios.get(`${API}/executor-mode/letters/${kind}.pdf`, { responseType: "blob" })).data;
export const householdLinks = async () => (await axios.get(`${API}/household/links`)).data;
export const householdLinkCreate = async (label) => (await axios.post(`${API}/household/links`, { label })).data;
export const householdLinkRevoke = async (token) => (await axios.delete(`${API}/household/links/invites/${token}`)).data;
export const householdUnlink = async (slug) => (await axios.delete(`${API}/household/links/${slug}`)).data;
export const keySharePlans = async () => (await axios.get(`${API}/key-shares`)).data;
export const keyShareCreate = async (payload) => (await axios.post(`${API}/key-shares`, payload)).data;
export const keyShareDelete = async (id) => (await axios.delete(`${API}/key-shares/${id}`)).data;
export const keyShareVerify = async (id, share) => (await axios.post(`${API}/key-shares/${id}/verify`, { share })).data;
export const denyAccessRequest = async (id) => (await axios.post(`${API}/access-requests/${id}/deny`)).data;

export const emailStatus = async () => {
  const { data } = await axios.get(`${API}/email/status`);
  return data;
};

export const setEmailSender = async (from_address) => {
  const { data } = await axios.put(`${API}/email/sender`, { from_address });
  return data;
};
export const setEmailPostal = async (postal_address) => (await axios.put(`${API}/email/postal`, { postal_address })).data;

// Fax intake (Telnyx), state statutory forms, signing-day invites, draft-vs-signed comparison
export const faxStatus = async () => (await axios.get(`${API}/fax/status`)).data;
export const faxProvision = async (number) => (await axios.post(`${API}/fax/number`, { number })).data;
export const faxRelease = async () => (await axios.delete(`${API}/fax/number`)).data;
export const stateForms = async () => (await axios.get(`${API}/state-forms`)).data;
export const estateDraftSigning = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/signing`)).data;
export const estateDraftSaveSigning = async (kind, body) => (await axios.put(`${API}/estate-drafts/${kind}/signing`, body)).data;
export const estateDraftInvite = async (kind, party_ids = []) => (await axios.post(`${API}/estate-drafts/${kind}/signing/invite`, { party_ids })).data;
export const estateDraftIcsUrl = (kind) => `${API}/estate-drafts/${kind}/signing/event.ics`;
export const estateDraftCompare = async (kind, refresh = false) => (await axios.get(`${API}/estate-drafts/${kind}/compare`, { params: refresh ? { refresh: 1 } : {} })).data;
export const estateDraftNotaries = async (kind, near, refresh = false) => (await axios.get(`${API}/estate-drafts/${kind}/signing/notaries`, { params: { near, ...(refresh ? { refresh: 1 } : {}) } })).data;
export const estateDraftOcr = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/compare/ocr`)).data;
export const estateDraftPickSigned = async (kind, document_id) => (await axios.put(`${API}/estate-drafts/${kind}/signed`, { document_id })).data;
export const faxSyncWebhook = async () => (await axios.post(`${API}/fax/webhook/sync`)).data;

// Passkeys (WebAuthn)
export const passkeyList = async () => (await axios.get(`${API}/webauthn/credentials`)).data;
export const passkeyRegisterOptions = async () => (await axios.post(`${API}/webauthn/registration/options`)).data;
export const passkeyRegisterVerify = async (credential, label) => (await axios.post(`${API}/webauthn/registration/verify`, { ...credential, label })).data;
export const passkeyDelete = async (id) => (await axios.delete(`${API}/webauthn/credentials/${id}`)).data;
export const passkeyAuthOptions = async (pending) => (await axios.post(`${API}/webauthn/authentication/options`, { pending })).data;
export const passkeyAuthVerify = async (credential, pending) => (await axios.post(`${API}/webauthn/authentication/verify`, { ...credential, pending })).data;
export const passkeyOtpFallback = async (pending) => (await axios.post(`${API}/webauthn/otp-fallback`, { pending })).data;

// Browser extension capture tokens
export const extensionToken = async () => (await axios.get(`${API}/extension/token`)).data;
export const extensionTokenCreate = async () => (await axios.post(`${API}/extension/token`)).data;
export const extensionTokenRevoke = async () => (await axios.delete(`${API}/extension/token`)).data;

export const calendarMembers = async () => (await axios.get(`${API}/calendar/members`)).data;
export const calendarMemberRotate = async (memberId) => (await axios.post(`${API}/calendar/members/${memberId}`)).data;
export const calendarMemberDisable = async (memberId) => (await axios.delete(`${API}/calendar/members/${memberId}`)).data;
export const fetchPolicies = async () => (await axios.get(`${API}/policies`)).data;
export const fetchPolicy = async (id) => (await axios.get(`${API}/policies/${id}`)).data;
export const signPolicy = async (id, payload) => (await axios.post(`${API}/policies/${id}/sign`, payload)).data;
export const estateDraftSmsTest = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/signing/sms-test`)).data;
export const upcomingSigningDays = async () => (await axios.get(`${API}/estate-drafts/signing-day/upcoming`)).data;
export const reviewPolicy = async (id, note = "") => (await axios.post(`${API}/policies/${id}/review`, { note })).data;
export const estateDraftPhotoProof = async (kind, files) => { const f = new FormData(); [...files].forEach((x) => f.append("files", x)); return (await axios.post(`${API}/estate-drafts/${kind}/signed/photos`, f)).data; };
export const policyPackUrl = () => `${API}/policies/export/pack.zip`;
export const createPolicyShare = async (payload) => (await axios.post(`${API}/policies/export/share`, payload)).data;
export const listPolicyShares = async () => (await axios.get(`${API}/policies/export/shares`)).data;
export const estateDraftPhotoRetake = async (kind, files) => { const f = new FormData(); [...files].forEach((x) => f.append("files", x)); return (await axios.post(`${API}/estate-drafts/${kind}/signed/photos/retake`, f)).data; };
export const estateDraftSendFlags = async (kind, payload) => (await axios.post(`${API}/estate-drafts/${kind}/compare/send-attorney`, payload)).data;
export const unlockOtpCall = async (challengeId) => (await axios.post(`${API}/security/unlock/otp/call`, { challenge_id: challengeId })).data;
export const shareComments = async (linkId, token) => (await axios.get(`${API}/share/${linkId}/comments`, { params: { t: token } })).data;
export const shareCommentAdd = async (linkId, token, payload) => (await axios.post(`${API}/share/${linkId}/comments?t=${encodeURIComponent(token)}`, payload)).data;
export const policyComments = async () => (await axios.get(`${API}/policies/comments/all`)).data;
export const policyCommentReply = async (id, text) => (await axios.post(`${API}/policies/comments/${id}/reply`, { text })).data;

// --- Compliance Center (Administrator) ---
export const complianceOverview = async () => (await axios.get(`${API}/admin/compliance`)).data;
export const compliancePolicyApproveAll = async () => (await axios.post(`${API}/admin/compliance/policies/approve-all`)).data;
export const complianceRisks = async () => (await axios.get(`${API}/admin/compliance/risks`)).data;
export const complianceRiskSeed = async () => (await axios.post(`${API}/admin/compliance/risks/seed`)).data;
export const complianceRiskCreate = async (payload) => (await axios.post(`${API}/admin/compliance/risks`, payload)).data;
export const complianceRiskUpdate = async (rid, payload) => (await axios.put(`${API}/admin/compliance/risks/${rid}`, payload)).data;
export const complianceRiskDelete = async (rid) => (await axios.delete(`${API}/admin/compliance/risks/${rid}`)).data;
export const complianceRiskReviewAll = async () => (await axios.post(`${API}/admin/compliance/risks/review-all`)).data;
export const reviewerStatus = async () => (await axios.get(`${API}/admin/reviewer`)).data;
export const reviewerReset = async (payload) => (await axios.post(`${API}/admin/reviewer`, payload)).data;
export const adminHouseholdsExportCsv = async () => {
  const res = await axios.get(`${API}/admin/households/export.csv`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `hearthvault-households-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};
export const compliancePolicyGenerate = async () => (await axios.post(`${API}/admin/compliance/policies/generate`)).data;
export const compliancePolicy = async (pid) => (await axios.get(`${API}/admin/compliance/policies/${pid}`)).data;
export const compliancePolicyUpdate = async (pid, payload) => (await axios.put(`${API}/admin/compliance/policies/${pid}`, payload)).data;
export const complianceControlUpdate = async (cid, payload) => (await axios.put(`${API}/admin/compliance/controls/${cid}`, payload)).data;
export const complianceAccessReview = async () => (await axios.post(`${API}/admin/compliance/access-review`)).data;
export const complianceRestoreDrill = async () => (await axios.post(`${API}/admin/compliance/restore-drill`)).data;
export const complianceExport = async () => {
  const res = await axios.get(`${API}/admin/compliance/export`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/zip" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `hearthvault-soc2-evidence-${new Date().toISOString().slice(0, 10)}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
export const draftReview = async (kind) => (await axios.get(`${API}/estate-drafts/${kind}/review`)).data;
export const draftReviewRun = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/review`)).data;
export const statuteWatch = async () => (await axios.get(`${API}/admin/statute-watch`)).data;
export const statuteWatchKey = async (api_key) => (await axios.put(`${API}/admin/statute-watch/key`, { api_key })).data;
export const statuteWatchClear = async () => (await axios.delete(`${API}/admin/statute-watch/key`)).data;
export const statuteWatchRun = async (states = "") => (await axios.post(`${API}/admin/statute-watch/run`, null, { params: { states } })).data;
export const statuteWatchAck = async (billId) => (await axios.post(`${API}/admin/statute-watch/hits/${billId}/ack`)).data;
export const notarizeCheckout = async (kind, payload) => (await axios.post(`${API}/estate-drafts/${kind}/notarize/checkout`, payload)).data;
export const notarizeRefund = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/notarize/refund`)).data;
export const notaryPricing = async (payload) => (await axios.put(`${API}/admin/notary-config/pricing`, payload)).data;
export const notaryStats = async () => (await axios.get(`${API}/admin/notary-config/stats`)).data;
export const notaryQueue = async () => (await axios.get(`${API}/admin/notary-config/queue`)).data;
export const notaryQueueResend = async (payload) => (await axios.post(`${API}/admin/notary-config/queue/resend`, payload)).data;
export const notarizeResend = async (kind) => (await axios.post(`${API}/estate-drafts/${kind}/notarize/resend`)).data;
export const notarySaveOneNotary = async (payload) => (await axios.put(`${API}/admin/notary-config/onenotary`, payload)).data;
export const notaryClearOneNotary = async () => (await axios.delete(`${API}/admin/notary-config/onenotary`)).data;
export const vitalRecordsPublic = async () => (await axios.get(`${API}/site/vital-records`)).data;
export const vitalRecordsAdmin = async () => (await axios.get(`${API}/admin/vital-records`)).data;
export const vitalRecordsSet = async (abbr, payload) => (await axios.put(`${API}/admin/vital-records/${abbr}`, payload)).data;
export const vitalRecordsClear = async (abbr) => (await axios.delete(`${API}/admin/vital-records/${abbr}`)).data;
export const vitalRecordsVerified = async (abbr) => (await axios.post(`${API}/admin/vital-records/verified`, { abbr: abbr || null })).data;
export const certOrders = async () => (await axios.get(`${API}/executor-mode/cert-orders`)).data;
export const certOrderAdd = async (payload) => (await axios.post(`${API}/executor-mode/cert-orders`, payload)).data;
export const certOrderPatch = async (id, payload) => (await axios.patch(`${API}/executor-mode/cert-orders/${id}`, payload)).data;
export const certOrderDelete = async (id) => (await axios.delete(`${API}/executor-mode/cert-orders/${id}`)).data;
export const certOrderUsed = async (payload) => (await axios.post(`${API}/executor-mode/cert-orders/used`, payload)).data;
export const certRecipientAdd = async (name) => (await axios.post(`${API}/executor-mode/cert-recipients`, { name })).data;
export const certRecipientDelete = async (id) => (await axios.delete(`${API}/executor-mode/cert-recipients/${id}`)).data;
export const vitalAutoCheckRun = async (abbrs) => (await axios.post(`${API}/admin/vital-records/auto-check`, { abbrs: abbrs || [] })).data;
export const vitalAutoCheckResults = async () => (await axios.get(`${API}/admin/vital-records/auto-check`)).data;
export const idvStatus = async () => (await axios.get(`${API}/identity/status`)).data;
export const idvStart = async () => (await axios.post(`${API}/identity/start`)).data;
export const identityConfig = async () => (await axios.get(`${API}/admin/identity-config`)).data;
export const identitySaveConfig = async (payload) => (await axios.put(`${API}/admin/identity-config`, payload)).data;
export const identityClearConfig = async () => (await axios.delete(`${API}/admin/identity-config`)).data;
export const identityMembers = async () => (await axios.get(`${API}/admin/identity/members`)).data;
export const setDocumentProperty = async (id, property_address) => (await axios.patch(`${API}/documents/${id}/property`, { property_address })).data;
export const fetchProperties = async () => (await axios.get(`${API}/properties`)).data;
export const contactLetterBlob = async (contactId) => (await axios.get(`${API}/estate-plan/contacts/${contactId}/letter.pdf`, { responseType: "blob" })).data;
export const pushVapidKey = async () => (await axios.get(`${API}/push/vapid-public-key`)).data;
export const pushStatus = async () => (await axios.get(`${API}/push/status`)).data;
export const pushSubscribe = async (sub) => (await axios.post(`${API}/push/subscribe`, sub)).data;
export const pushUnsubscribe = async (endpoint = "") => (await axios.delete(`${API}/push/subscribe`, { data: { endpoint } })).data;
export const pushTest = async () => (await axios.post(`${API}/push/test`)).data;
export const stripeAccount = async () => (await axios.get(`${API}/admin/stripe/account`)).data;
export const stripeBuildCatalog = async () => (await axios.post(`${API}/admin/stripe/catalog`)).data;
export const retentionState = async () => (await axios.get(`${API}/retention/state`)).data;
export const retentionStart = async (body) => (await axios.post(`${API}/retention/start`, body)).data;
export const retentionAccept = async (body) => (await axios.post(`${API}/retention/accept`, body)).data;
export const retentionCancel = async (body) => (await axios.post(`${API}/retention/cancel`, body)).data;
export const retentionKeep = async () => (await axios.post(`${API}/retention/keep`)).data;
export const retentionResume = async () => (await axios.post(`${API}/retention/resume`)).data;
export const adminRetention = async () => (await axios.get(`${API}/admin/retention`)).data;
export const adminRetentionSave = async (body) => (await axios.put(`${API}/admin/retention`, body)).data;
export const allLettersBlob = async () => (await axios.get(`${API}/estate-plan/contacts/letters.pdf`, { responseType: "blob" })).data;
export const contactLabelsBlob = async () => (await axios.get(`${API}/estate-plan/contacts/labels.pdf`, { responseType: "blob" })).data;
export const retentionExtendPause = async (months = 1) => (await axios.post(`${API}/retention/extend-pause`, { months })).data;
export const retentionWhatsNew = async () => (await axios.get(`${API}/retention/whats-new`)).data;
export const assetCsvPreview = async (file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/life-admin/assets/import-csv/preview`, fd)).data; };
export const assetCsvCommit = async (rows, source) => (await axios.post(`${API}/life-admin/assets/import-csv/commit`, { rows, source })).data;
export const conciergeSlots = async (kind = "planning") => (await axios.get(`${API}/concierge/slots?kind=${kind}`)).data;
export const conciergeBook = async (body) => (await axios.post(`${API}/concierge/book`, body)).data;
export const conciergeCancel = async (id) => (await axios.post(`${API}/concierge/cancel/${id}`)).data;
export const conciergeAdmin = async () => (await axios.get(`${API}/concierge/admin`)).data;
export const conciergeAdminSettings = async (body) => (await axios.put(`${API}/concierge/admin/settings`, body)).data;
export const conciergeAdminCancel = async (id) => (await axios.post(`${API}/concierge/admin/cancel/${id}`)).data;
export const kpiCohorts = async (refresh = false) => (await axios.get(`${API}/admin/kpi/cohorts${refresh ? "?refresh=true" : ""}`)).data;
export const recaptionDocument = async (id) => (await axios.post(`${API}/documents/${id}/recaption`)).data;
export const addChapter = async (id, body) => (await axios.post(`${API}/documents/${id}/chapters`, body)).data;
export const removeChapter = async (id, chapterId) => (await axios.delete(`${API}/documents/${id}/chapters/${chapterId}`)).data;
export const recordingShares = async (id) => (await axios.get(`${API}/documents/${id}/shares`)).data;
export const createRecordingShare = async (id, body) => (await axios.post(`${API}/documents/${id}/shares`, body)).data;
export const revokeRecordingShare = async (id, token) => (await axios.delete(`${API}/documents/${id}/shares/${token}`)).data;
export const publicLetter = async (token) => (await axios.get(`${API}/public/letter/${token}`)).data;
export const publicLetterMedia = (token, poster = false) => `${API}/public/letter/${token}/media${poster ? "?poster=1" : ""}`;
export const emailRecordingShare = async (id, token, body) => (await axios.post(`${API}/documents/${id}/shares/${token}/email`, body)).data;
export const recordingReplies = async (id) => (await axios.get(`${API}/documents/${id}/replies`)).data;
export const deleteRecordingReply = async (id, replyId) => (await axios.delete(`${API}/documents/${id}/replies/${replyId}`)).data;
export const publicLetterReplies = async (token) => (await axios.get(`${API}/public/letter/${token}/replies`)).data;
export const publicLetterReply = async (token, fd, onProgress) => (await axios.post(`${API}/public/letter/${token}/reply`, fd, { onUploadProgress: (e) => onProgress?.(e.total ? e.loaded / e.total : 0) })).data;
export const portalVisit = async (slug, src) => (await axios.post(`${API}/portal/${slug}/visit`, { src })).data;
export const advisorReferrals = async () => (await axios.get(`${API}/advisor/referrals`)).data;
export const advisorCompareStats = async () => (await axios.get(`${API}/advisor/compare-stats`)).data;

// E-sign
export const esignList = async () => (await axios.get(`${API}/esign`)).data;
export const esignPeople = async () => (await axios.get(`${API}/esign/people`)).data;
export const esignCreate = async (body) => (await axios.post(`${API}/esign`, body)).data;
export const esignRemind = async (rid, sid) => (await axios.post(`${API}/esign/${rid}/remind/${sid}`)).data;
export const esignCancel = async (rid) => (await axios.post(`${API}/esign/${rid}/cancel`)).data;
export const esignSignInApp = async (rid, body) => (await axios.post(`${API}/esign/${rid}/sign`, body)).data;
export const esignPdfUrl = (rid) => `${API}/esign/${rid}/document.pdf`;
export const esignPublic = async (token) => (await axios.get(`${API}/esign/public/${token}`)).data;
export const esignPublicPdfUrl = (token) => `${API}/esign/public/${token}/document.pdf`;
export const esignPublicSign = async (token, body) => (await axios.post(`${API}/esign/public/${token}/sign`, body)).data;
export const esignPublicDecline = async (token, reason) => (await axios.post(`${API}/esign/public/${token}/decline`, { reason })).data;
// Upload auto-updates + renewal reminders
export const autofillList = async () => (await axios.get(`${API}/autofill`)).data;
export const autofillUndo = async (id) => (await axios.post(`${API}/autofill/${id}/undo`)).data;
export const renewalsOverview = async () => (await axios.get(`${API}/renewals`)).data;
export const renewalsSetting = async (enabled) => (await axios.put(`${API}/renewals/settings`, { enabled })).data;
export const renewalsSendNow = async () => (await axios.post(`${API}/renewals/send-now`)).data;
// Concierge session notes
export const conciergeSessions = async () => (await axios.get(`${API}/concierge/sessions`)).data;
export const conciergeTodoToggle = async (bid, tid) => (await axios.post(`${API}/concierge/sessions/${bid}/todo/${tid}`)).data;
export const conciergeComment = async (bid, text) => (await axios.post(`${API}/concierge/sessions/${bid}/comment`, { text })).data;
export const conciergeAdminNotes = async (bid, body) => (await axios.put(`${API}/concierge/admin/notes/${bid}`, body)).data;
export const conciergeAdminComment = async (bid, text) => (await axios.post(`${API}/concierge/admin/comment/${bid}`, { text })).data;
export const esignPreviewMeta = async (docId) => (await axios.get(`${API}/esign/preview/${docId}`)).data;
export const esignPreviewPage = async (docId, page) => URL.createObjectURL((await axios.get(`${API}/esign/preview/${docId}/${page}.png?w=900`, { responseType: "blob" })).data);
export const esignUploadNotarized = async (rid, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/esign/${rid}/notarized`, fd, { timeout: 180000 })).data; };
export const autofillConfirm = async (id) => (await axios.post(`${API}/autofill/${id}/confirm`)).data;
export const esignTemplates = async () => (await axios.get(`${API}/esign/templates`)).data;
export const esignSaveTemplate = async (body) => (await axios.post(`${API}/esign/templates`, body)).data;
export const esignDeleteTemplate = async (id) => (await axios.delete(`${API}/esign/templates/${id}`)).data;
export const esignPublicCode = async (token) => (await axios.post(`${API}/esign/public/${token}/code`)).data;
export const esignPublicVerify = async (token, code) => (await axios.post(`${API}/esign/public/${token}/verify`, { code })).data;
export const ceremonyApi = (base) => ({
  code: async (sid) => (await axios.post(`${API}/esign/${base}/ceremony/${sid}/code`)).data,
  verify: async (sid, code) => (await axios.post(`${API}/esign/${base}/ceremony/${sid}/verify`, { code })).data,
  sign: async (sid, body) => (await axios.post(`${API}/esign/${base}/ceremony/${sid}/sign`, body)).data,
});
export const localDate = () => { const d = new Date(); return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}/${d.getFullYear()}`; };
export const esignShareTargets = async () => (await axios.get(`${API}/esign/share-targets`)).data;
export const esignShareTemplate = async (tid, body) => (await axios.post(`${API}/esign/templates/${tid}/share`, body)).data;
export const esignTemplateChecklistUrl = (tid, state = "") => `${API}/esign/templates/${tid}/checklist.pdf${state ? `?state=${state}` : ""}`;
export const esignSendInvite = async (tid, body) => (await axios.post(`${API}/esign/templates/${tid}/invite`, body)).data;
export const esignAlertSettings = async () => (await axios.get(`${API}/esign/alert-settings`)).data;
export const esignSaveAlertSettings = async (body) => (await axios.put(`${API}/esign/alert-settings`, body)).data;
export const adminStateRules = async () => (await axios.get(`${API}/admin/state-signing-rules`)).data;
export const stateSigningRules = async (st) => (await axios.get(`${API}/state-signing-rules/${st}`)).data;
export const accessCodes = async () => (await axios.get(`${API}/access-codes`)).data;
export const accessCodeSave = async (id, body) => (id ? await axios.put(`${API}/access-codes/${id}`, body) : await axios.post(`${API}/access-codes`, body)).data;
export const accessCodeDelete = async (id) => (await axios.delete(`${API}/access-codes/${id}`)).data;
export const accessCodeReveal = async (id) => (await axios.post(`${API}/access-codes/${id}/reveal`)).data;
export const accessCodeStillSame = async (id, action) => (await axios.post(`${API}/access-codes/${id}/still-same`, { action })).data;
export const guestCodeShare = async (id, body) => (await axios.post(`${API}/access-codes/${id}/guest`, body)).data;
export const guestCodeLinks = async (id) => (await axios.get(`${API}/access-codes/${id}/guests`)).data;
export const guestCodeRevoke = async (gid) => (await axios.delete(`${API}/access-codes/guests/${gid}`)).data;
export const guestCodeOpen = async (token) => (await axios.get(`${API}/guest-code/${token}`)).data;
export const draftRulesCheck = async (kid) => (await axios.get(`${API}/estate-drafts/${kid}/rules-check`, { timeout: 90000 })).data;
export const adminSaveStateRule = async (st, body) => (await axios.put(`${API}/admin/state-signing-rules/${st}`, body)).data;
export const adminResetStateRule = async (st) => (await axios.delete(`${API}/admin/state-signing-rules/${st}`)).data;
export const sharedTemplate = async (token) => (await axios.get(`${API}/esign/shared/${token}`)).data;
export const sharedTemplateUrl = (token, what) => `${API}/esign/shared/${token}/${what}.pdf`;
export const advisorEsignTemplates = async () => (await axios.get(`${API}/advisor/esign-templates`)).data;
export const advisorEsignChecklistUrl = (tid) => `${API}/advisor/esign-templates/${tid}/checklist.pdf`;
export const advisorAddTemplate = async (tid, clientId) => (await axios.post(`${API}/advisor/esign-templates/${tid}/add/${clientId}`)).data;
export const advisorDeleteTemplate = async (tid) => (await axios.delete(`${API}/advisor/esign-templates/${tid}`)).data;
export const advisorUploadTemplate = async (fd) => (await axios.post(`${API}/advisor/esign-templates/upload`, fd, { timeout: 120000 })).data;
export const advisorSetStarter = async (tid, starter) => (await axios.patch(`${API}/advisor/esign-templates/${tid}`, { starter })).data;
export const advisorSendStarter = async (clientId) => (await axios.post(`${API}/advisor/esign-templates/starter/${clientId}`)).data;
export const supportContact = async () => (await axios.get(`${API}/support/contact`)).data;
export const supportContactSave = async (reply_time) => (await axios.put(`${API}/support/contact`, { reply_time })).data;
export const supportNoticeSave = async (body) => (await axios.put(`${API}/support/contact/notice`, body)).data;
export const roadmapList = async () => (await axios.get(`${API}/roadmap`, { withCredentials: true })).data;
export const roadmapVote = async (id) => (await axios.post(`${API}/roadmap/${id}/vote`, {}, { withCredentials: true })).data;
export const roadmapSuggest = async (body) => (await axios.post(`${API}/roadmap/suggest`, body)).data;
export const roadmapAdmin = async () => (await axios.get(`${API}/roadmap/admin/items`)).data;
export const roadmapAdminCreate = async (body) => (await axios.post(`${API}/roadmap/admin/items`, body)).data;
export const roadmapAdminUpdate = async (id, body) => (await axios.patch(`${API}/roadmap/admin/items/${id}`, body)).data;
export const roadmapAdminDelete = async (id) => (await axios.delete(`${API}/roadmap/admin/items/${id}`)).data;
export const roadmapNotify = async (id, email) => (await axios.post(`${API}/roadmap/${id}/notify`, { email })).data;
export const securityAuditSave = async (body) => (await axios.put(`${API}/admin/security-audit`, body)).data;
export const partnerPage = async (slug, k) => (await axios.get(`${API}/promo/partner/${slug}`, { params: k ? { k } : {} })).data;
export const partnerGet = async (code) => (await axios.get(`${API}/promo/admin/${code}/partner`)).data;
export const partnerSave = async (code, body) => (await axios.put(`${API}/promo/admin/${code}/partner`, body)).data;
export const checklistAgingAlone = async () => (await axios.get(`${API}/checklists/aging-alone`)).data;
export const checklistImport = async (undone) => (await axios.post(`${API}/checklists/aging-alone/import`, { undone })).data;
export const partnerStatsPublic = async (key) => (await axios.get(`${API}/promo/partner-stats/${key}`)).data;
export const partnerSelfIntroUpload = async (key, file) => { const fd = new FormData(); fd.append("file", file, file.name || "welcome.webm"); return (await axios.post(`${API}/promo/partner-stats/${key}/intro-audio`, fd)).data; };
export const partnerSelfDraftScript = async (key) => (await axios.post(`${API}/promo/partner-stats/${key}/welcome-script`)).data;
export const partnerSelfSaveScript = async (key, script) => (await axios.put(`${API}/promo/partner-stats/${key}/welcome-script`, { script })).data;
export const partnerSelfIntroUrl = (key, v = 0) => `${API}/promo/partner-stats/${key}/intro-audio?v=${v}`;
export const partnerDraftScript = async (code) => (await axios.post(`${API}/promo/admin/${code}/partner/welcome-script`)).data;
export const partnerSaveScript = async (code, script) => (await axios.put(`${API}/promo/admin/${code}/partner/welcome-script`, { script })).data;
export const lettersAlbumCover = async () => (await axios.get(`${API}/voice/letters/album/cover`)).data;
export const lettersAlbumCoverPdf = async () => (await axios.get(`${API}/voice/letters/album/cover.pdf`, { responseType: "blob" })).data;
export const partnerNudgePreview = async (code) => (await axios.get(`${API}/promo/admin/${code}/partner/nudge`)).data;
export const partnerNudgeSend = async (code) => (await axios.post(`${API}/promo/admin/${code}/partner/nudge`)).data;
export const videoMarketing = async (body) => (await axios.post(`${API}/video/marketing`, body)).data;
export const videoPhoto = async ({ file, letter_id, prompt, for_reel }) => { const fd = new FormData(); fd.append("file", file); fd.append("letter_id", letter_id || ""); fd.append("prompt", prompt || ""); fd.append("for_reel", for_reel ? "true" : "false"); return (await axios.post(`${API}/video/photo`, fd)).data; };
export const videoReel = async (job_ids, title) => (await axios.post(`${API}/video/reel`, { job_ids, title })).data;
export const memorialReel = async () => (await axios.get(`${API}/memorial/reel`)).data;
export const memorialReelSet = async (job_id) => (await axios.put(`${API}/memorial/reel`, { job_id })).data;
export const partnerClipMake = async (code) => (await axios.post(`${API}/promo/admin/${code}/partner/clip`, {})).data;
export const partnerClipApprove = async (code, approved) => (await axios.post(`${API}/promo/admin/${code}/partner/clip/approve`, { approved })).data;
export const youtubeFeed = async () => (await axios.get(`${API}/public/youtube`)).data;
export const youtubeSave = async (url) => (await axios.put(`${API}/admin/youtube`, { url })).data;
export const youtubeFeatured = async (url) => (await axios.put(`${API}/admin/youtube/featured`, { url })).data;
export const reelMusic = async () => (await axios.get(`${API}/memorial/reel/music`)).data;
export const reelMusicLibrary = async (mood) => (await axios.put(`${API}/memorial/reel/music/library`, { mood })).data;
export const reelMusicCompose = async () => (await axios.post(`${API}/memorial/reel/music/compose`)).data;
export const reelMusicUpload = async (file) => { const fd = new FormData(); fd.append("file", file); fd.append("rights", "true"); return (await axios.post(`${API}/memorial/reel/music/upload`, fd, { timeout: 180000 })).data; };
export const reelMusicRemove = async () => (await axios.delete(`${API}/memorial/reel/music`)).data;
export const reelMusicAudioUrl = (mood = "", v = "") => `${API}/memorial/reel/music/audio?mood=${mood}&v=${encodeURIComponent(v)}`;
export const faxSendDoc = async (body) => (await axios.post(`${API}/fax/send`, body)).data;
export const faxSends = async () => (await axios.get(`${API}/fax/sends`)).data;
export const videoJobs = async (params) => (await axios.get(`${API}/video/jobs`, { params: Object.fromEntries(Object.entries(params).filter(([, v]) => v)) })).data;
export const videoDelete = async (id) => (await axios.delete(`${API}/video/jobs/${id}`)).data;
export const videoFileUrl = (id, dl = false) => `${API}/video/jobs/${id}/file${dl ? "?dl=1" : ""}`;
export const lettersAlbum = async () => (await axios.get(`${API}/voice/letters/album`, { responseType: "blob", timeout: 300000 })).data;
export const partnerReportNow = async (code) => (await axios.post(`${API}/promo/admin/${code}/partner/report-now`)).data;
export const partnerIntroUpload = async (code, file) => { const fd = new FormData(); fd.append("file", file); return (await axios.post(`${API}/promo/admin/${code}/partner/intro-audio`, fd)).data; };
export const partnerIntroDelete = async (code) => (await axios.delete(`${API}/promo/admin/${code}/partner/intro-audio`)).data;
export const voiceNeedsVoice = async () => (await axios.get(`${API}/voice/needs-voice`)).data;
export const partnerAdminStats = async (code) => (await axios.get(`${API}/promo/admin/${code}/partner/stats`)).data;
export const partnerPayoutAdd = async (code, body) => (await axios.post(`${API}/promo/admin/${code}/partner/payouts`, body)).data;
export const partnerPayoutDelete = async (code, id) => (await axios.delete(`${API}/promo/admin/${code}/partner/payouts/${id}`)).data;
export const keyRotationStatus = async () => (await axios.get(`${API}/admin/key-rotation`)).data;
